/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedWireRequestsIndexRouteImport } from './routes/_authenticated/wire-requests/index'
import { Route as AuthenticatedWireRequestEscalationsIndexRouteImport } from './routes/_authenticated/wire-request-escalations/index'
import { Route as AuthenticatedVendorsIndexRouteImport } from './routes/_authenticated/vendors/index'
import { Route as AuthenticatedValuationsIndexRouteImport } from './routes/_authenticated/valuations/index'
import { Route as AuthenticatedValuationEntriesIndexRouteImport } from './routes/_authenticated/valuation-entries/index'
import { Route as AuthenticatedV0IndexRouteImport } from './routes/_authenticated/v0/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedUnauthorizedIndexRouteImport } from './routes/_authenticated/unauthorized/index'
import { Route as AuthenticatedTransactionsIndexRouteImport } from './routes/_authenticated/transactions/index'
import { Route as AuthenticatedTaxesIndexRouteImport } from './routes/_authenticated/taxes/index'
import { Route as AuthenticatedTaxPenaltiesIndexRouteImport } from './routes/_authenticated/tax-penalties/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSyndicatesIndexRouteImport } from './routes/_authenticated/syndicates/index'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support/index'
import { Route as AuthenticatedSpvFeeDiscountsIndexRouteImport } from './routes/_authenticated/spv-fee-discounts/index'
import { Route as AuthenticatedSkillsIndexRouteImport } from './routes/_authenticated/skills/index'
import { Route as AuthenticatedSignatureLogsIndexRouteImport } from './routes/_authenticated/signature-logs/index'
import { Route as AuthenticatedSideLettersIndexRouteImport } from './routes/_authenticated/side-letters/index'
import { Route as AuthenticatedSellOrderRequestsIndexRouteImport } from './routes/_authenticated/sell-order-requests/index'
import { Route as AuthenticatedSecurityIndexRouteImport } from './routes/_authenticated/security/index'
import { Route as AuthenticatedSecondariesIndexRouteImport } from './routes/_authenticated/secondaries/index'
import { Route as AuthenticatedSearchIndexRouteImport } from './routes/_authenticated/search/index'
import { Route as AuthenticatedSalesIndexRouteImport } from './routes/_authenticated/sales/index'
import { Route as AuthenticatedRewardsIndexRouteImport } from './routes/_authenticated/rewards/index'
import { Route as AuthenticatedRegulatoryFilingsIndexRouteImport } from './routes/_authenticated/regulatory-filings/index'
import { Route as AuthenticatedQueueMonitorIndexRouteImport } from './routes/_authenticated/queue-monitor/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedProductsPricingIndexRouteImport } from './routes/_authenticated/products-pricing/index'
import { Route as AuthenticatedPledgesIndexRouteImport } from './routes/_authenticated/pledges/index'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedMigrationsIndexRouteImport } from './routes/_authenticated/migrations/index'
import { Route as AuthenticatedMeowBankingIndexRouteImport } from './routes/_authenticated/meow-banking/index'
import { Route as AuthenticatedMembershipTransfersIndexRouteImport } from './routes/_authenticated/membership-transfers/index'
import { Route as AuthenticatedMcpKeysIndexRouteImport } from './routes/_authenticated/mcp-keys/index'
import { Route as AuthenticatedMasterIndexRouteImport } from './routes/_authenticated/master/index'
import { Route as AuthenticatedMailIndexRouteImport } from './routes/_authenticated/mail/index'
import { Route as AuthenticatedLogsIndexRouteImport } from './routes/_authenticated/logs/index'
import { Route as AuthenticatedLegalTemplatesIndexRouteImport } from './routes/_authenticated/legal-templates/index'
import { Route as AuthenticatedLegalDocumentsIndexRouteImport } from './routes/_authenticated/legal-documents/index'
import { Route as AuthenticatedLedgerIndexRouteImport } from './routes/_authenticated/ledger/index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices/index'
import { Route as AuthenticatedInvoiceRequestsIndexRouteImport } from './routes/_authenticated/invoice-requests/index'
import { Route as AuthenticatedInvoiceItemsIndexRouteImport } from './routes/_authenticated/invoice-items/index'
import { Route as AuthenticatedInvestorUpdatesIndexRouteImport } from './routes/_authenticated/investor-updates/index'
import { Route as AuthenticatedInvestorRecipientsIndexRouteImport } from './routes/_authenticated/investor-recipients/index'
import { Route as AuthenticatedInvestorNetworkIndexRouteImport } from './routes/_authenticated/investor-network/index'
import { Route as AuthenticatedInvestmentsIndexRouteImport } from './routes/_authenticated/investments/index'
import { Route as AuthenticatedIntercomIndexRouteImport } from './routes/_authenticated/intercom/index'
import { Route as AuthenticatedIncreaseBankingIndexRouteImport } from './routes/_authenticated/increase-banking/index'
import { Route as AuthenticatedIdentitiesIndexRouteImport } from './routes/_authenticated/identities/index'
import { Route as AuthenticatedGranolaIndexRouteImport } from './routes/_authenticated/granola/index'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated/goals/index'
import { Route as AuthenticatedFundsIndexRouteImport } from './routes/_authenticated/funds/index'
import { Route as AuthenticatedFundraisingIndexRouteImport } from './routes/_authenticated/fundraising/index'
import { Route as AuthenticatedFundManagersIndexRouteImport } from './routes/_authenticated/fund-managers/index'
import { Route as AuthenticatedFundManagerNetworkIndexRouteImport } from './routes/_authenticated/fund-manager-network/index'
import { Route as AuthenticatedFinancialsIndexRouteImport } from './routes/_authenticated/financials/index'
import { Route as AuthenticatedFilesIndexRouteImport } from './routes/_authenticated/files/index'
import { Route as AuthenticatedFeedbacksIndexRouteImport } from './routes/_authenticated/feedbacks/index'
import { Route as AuthenticatedFaqsIndexRouteImport } from './routes/_authenticated/faqs/index'
import { Route as AuthenticatedExternalRecipientsIndexRouteImport } from './routes/_authenticated/external-recipients/index'
import { Route as AuthenticatedEscalationsIndexRouteImport } from './routes/_authenticated/escalations/index'
import { Route as AuthenticatedEreborBankingIndexRouteImport } from './routes/_authenticated/erebor-banking/index'
import { Route as AuthenticatedEntitiesIndexRouteImport } from './routes/_authenticated/entities/index'
import { Route as AuthenticatedEmailsIndexRouteImport } from './routes/_authenticated/emails/index'
import { Route as AuthenticatedEmailTemplatesIndexRouteImport } from './routes/_authenticated/email-templates/index'
import { Route as AuthenticatedDistributionsIndexRouteImport } from './routes/_authenticated/distributions/index'
import { Route as AuthenticatedDealsIndexRouteImport } from './routes/_authenticated/deals/index'
import { Route as AuthenticatedDealsWithUnitsIndexRouteImport } from './routes/_authenticated/deals-with-units/index'
import { Route as AuthenticatedCrmIndexRouteImport } from './routes/_authenticated/crm/index'
import { Route as AuthenticatedComplianceIndexRouteImport } from './routes/_authenticated/compliance/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedClosesIndexRouteImport } from './routes/_authenticated/closes/index'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/chat/index'
import { Route as AuthenticatedCashAccountsIndexRouteImport } from './routes/_authenticated/cash-accounts/index'
import { Route as AuthenticatedCapitalCallsIndexRouteImport } from './routes/_authenticated/capital-calls/index'
import { Route as AuthenticatedBrokerageAccountsIndexRouteImport } from './routes/_authenticated/brokerage-accounts/index'
import { Route as AuthenticatedBrokerageAccountsAlpacaIndexRouteImport } from './routes/_authenticated/brokerage-accounts-alpaca/index'
import { Route as AuthenticatedBlueSkyFeesIndexRouteImport } from './routes/_authenticated/blue-sky-fees/index'
import { Route as AuthenticatedBannersIndexRouteImport } from './routes/_authenticated/banners/index'
import { Route as AuthenticatedBankingIndexRouteImport } from './routes/_authenticated/banking/index'
import { Route as AuthenticatedBankingProvidersIndexRouteImport } from './routes/_authenticated/banking-providers/index'
import { Route as AuthenticatedAtlasIndexRouteImport } from './routes/_authenticated/atlas/index'
import { Route as AuthenticatedAssetsIndexRouteImport } from './routes/_authenticated/assets/index'
import { Route as AuthenticatedAssetsCleanupIndexRouteImport } from './routes/_authenticated/assets-cleanup/index'
import { Route as AuthenticatedAssetValuationsIndexRouteImport } from './routes/_authenticated/asset-valuations/index'
import { Route as AuthenticatedArchiveRequestsIndexRouteImport } from './routes/_authenticated/archive-requests/index'
import { Route as AuthenticatedAppManagementIndexRouteImport } from './routes/_authenticated/app-management/index'
import { Route as AuthenticatedApiAccessManagerIndexRouteImport } from './routes/_authenticated/api-access-manager/index'
import { Route as AuthenticatedAllocationsBankingIndexRouteImport } from './routes/_authenticated/allocations-banking/index'
import { Route as AuthenticatedAiStudioIndexRouteImport } from './routes/_authenticated/ai-studio/index'
import { Route as AuthenticatedAgentsIndexRouteImport } from './routes/_authenticated/agents/index'
import { Route as AuthenticatedAdministratorsIndexRouteImport } from './routes/_authenticated/administrators/index'
import { Route as AuthenticatedActivitiesIndexRouteImport } from './routes/_authenticated/activities/index'
import { Route as AuthenticatedAccountsIndexRouteImport } from './routes/_authenticated/accounts/index'
import { Route as AuthenticatedAccessManagementIndexRouteImport } from './routes/_authenticated/access-management/index'
import { Route as AuthenticatedAiStudioChatIdRouteImport } from './routes/_authenticated/ai-studio/$chatId'
import { Route as AuthenticatedAccountsSpendByProductRouteImport } from './routes/_authenticated/accounts/spend-by-product'
import { Route as AuthenticatedAccountsSpendRouteImport } from './routes/_authenticated/accounts/spend'
import { Route as AuthenticatedValuationsIdIndexRouteImport } from './routes/_authenticated/valuations/$id/index'
import { Route as AuthenticatedTaxesMetricsIndexRouteImport } from './routes/_authenticated/taxes/metrics/index'
import { Route as AuthenticatedTaxesDiscrepanciesIndexRouteImport } from './routes/_authenticated/taxes/discrepancies/index'
import { Route as AuthenticatedSupportSearchIndexRouteImport } from './routes/_authenticated/support/search/index'
import { Route as AuthenticatedScriptsGenerateLegalDocsIndexRouteImport } from './routes/_authenticated/scripts/generate-legal-docs/index'
import { Route as AuthenticatedSalesPulseIndexRouteImport } from './routes/_authenticated/sales/pulse/index'
import { Route as AuthenticatedProductsPricingIdIndexRouteImport } from './routes/_authenticated/products-pricing/$id/index'
import { Route as AuthenticatedPledgesIdIndexRouteImport } from './routes/_authenticated/pledges/$id/index'
import { Route as AuthenticatedOrganizationsIdIndexRouteImport } from './routes/_authenticated/organizations/$id/index'
import { Route as AuthenticatedMeowBankingEntityIdIndexRouteImport } from './routes/_authenticated/meow-banking/$entityId/index'
import { Route as AuthenticatedMembershipTransfersIdIndexRouteImport } from './routes/_authenticated/membership-transfers/$id/index'
import { Route as AuthenticatedLogsTrackIndexRouteImport } from './routes/_authenticated/logs/track/index'
import { Route as AuthenticatedLogsApiIndexRouteImport } from './routes/_authenticated/logs/api/index'
import { Route as AuthenticatedInvestmentsIdIndexRouteImport } from './routes/_authenticated/investments/$id/index'
import { Route as AuthenticatedIncreaseBankingAccountIdIndexRouteImport } from './routes/_authenticated/increase-banking/$accountId/index'
import { Route as AuthenticatedIdentitiesIdIndexRouteImport } from './routes/_authenticated/identities/$id/index'
import { Route as AuthenticatedFundraisingPledgesIndexRouteImport } from './routes/_authenticated/fundraising/pledges/index'
import { Route as AuthenticatedFundraisingEmailsIndexRouteImport } from './routes/_authenticated/fundraising/emails/index'
import { Route as AuthenticatedFundraisingDataroomIndexRouteImport } from './routes/_authenticated/fundraising/dataroom/index'
import { Route as AuthenticatedFundraisingContactsIndexRouteImport } from './routes/_authenticated/fundraising/contacts/index'
import { Route as AuthenticatedFinancialsSheetsIndexRouteImport } from './routes/_authenticated/financials/sheets/index'
import { Route as AuthenticatedEntitiesIdIndexRouteImport } from './routes/_authenticated/entities/$id/index'
import { Route as AuthenticatedDistributionsWiresIndexRouteImport } from './routes/_authenticated/distributions/wires/index'
import { Route as AuthenticatedDistributionsIdIndexRouteImport } from './routes/_authenticated/distributions/$id/index'
import { Route as AuthenticatedDealsBulkUploadIndexRouteImport } from './routes/_authenticated/deals/bulk-upload/index'
import { Route as AuthenticatedDealsIdIndexRouteImport } from './routes/_authenticated/deals/$id/index'
import { Route as AuthenticatedComplianceBviIndexRouteImport } from './routes/_authenticated/compliance/bvi/index'
import { Route as AuthenticatedComplianceIdIndexRouteImport } from './routes/_authenticated/compliance/$id/index'
import { Route as AuthenticatedCompaniesIdIndexRouteImport } from './routes/_authenticated/companies/$id/index'
import { Route as AuthenticatedClosesIdIndexRouteImport } from './routes/_authenticated/closes/$id/index'
import { Route as AuthenticatedChatBugsIndexRouteImport } from './routes/_authenticated/chat/bugs/index'
import { Route as AuthenticatedChatIdIndexRouteImport } from './routes/_authenticated/chat/$id/index'
import { Route as AuthenticatedCapitalCallsIdIndexRouteImport } from './routes/_authenticated/capital-calls/$id/index'
import { Route as AuthenticatedBankingIdIndexRouteImport } from './routes/_authenticated/banking/$id/index'
import { Route as AuthenticatedAtlasSuggestionsIndexRouteImport } from './routes/_authenticated/atlas/suggestions/index'
import { Route as AuthenticatedAtlasPulseIndexRouteImport } from './routes/_authenticated/atlas/pulse/index'
import { Route as AuthenticatedAtlasOverviewIndexRouteImport } from './routes/_authenticated/atlas/overview/index'
import { Route as AuthenticatedAtlasDocumentationIndexRouteImport } from './routes/_authenticated/atlas/documentation/index'
import { Route as AuthenticatedAtlasDepartmentIndexRouteImport } from './routes/_authenticated/atlas/$department/index'
import { Route as AuthenticatedAssetsIdIndexRouteImport } from './routes/_authenticated/assets/$id/index'
import { Route as AuthenticatedAiStudioSettingsIndexRouteImport } from './routes/_authenticated/ai-studio/settings/index'
import { Route as AuthenticatedAccountsIdIndexRouteImport } from './routes/_authenticated/accounts/$id/index'
import { Route as AuthenticatedFinancialsSheetsSheetIdRouteImport } from './routes/_authenticated/financials/sheets/$sheetId'
import { Route as AuthenticatedAtlasSuggestionsIdRouteImport } from './routes/_authenticated/atlas/suggestions/$id'
import { Route as AuthenticatedAtlasDepartmentPageRouteImport } from './routes/_authenticated/atlas/$department/$page'
import { Route as AuthenticatedTaxesDiscrepanciesTax_yearIndexRouteImport } from './routes/_authenticated/taxes/discrepancies/$tax_year/index'
import { Route as AuthenticatedTaxesEntity_idTax_yearIndexRouteImport } from './routes/_authenticated/taxes/$entity_id/$tax_year/index'
import { Route as AuthenticatedSyndicatesIdAdminIndexRouteImport } from './routes/_authenticated/syndicates/$id/admin/index'
import { Route as AuthenticatedLedgerAccountsIdIndexRouteImport } from './routes/_authenticated/ledger/accounts/$id/index'
import { Route as AuthenticatedDistributionsIdDistributionsEventsIndexRouteImport } from './routes/_authenticated/distributions/$id/distributions-events/index'
import { Route as AuthenticatedComplianceBviManualIndexRouteImport } from './routes/_authenticated/compliance/bvi/manual/index'
import { Route as AuthenticatedComplianceBviFormationsIndexRouteImport } from './routes/_authenticated/compliance/bvi/formations/index'
import { Route as AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRouteImport } from './routes/_authenticated/distributions/$id/distributions-events/$eventId/index'
import { Route as AuthenticatedComplianceBviFormationsIdIndexRouteImport } from './routes/_authenticated/compliance/bvi/formations/$id/index'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWireRequestsIndexRoute =
  AuthenticatedWireRequestsIndexRouteImport.update({
    id: '/wire-requests/',
    path: '/wire-requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWireRequestEscalationsIndexRoute =
  AuthenticatedWireRequestEscalationsIndexRouteImport.update({
    id: '/wire-request-escalations/',
    path: '/wire-request-escalations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVendorsIndexRoute =
  AuthenticatedVendorsIndexRouteImport.update({
    id: '/vendors/',
    path: '/vendors/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedValuationsIndexRoute =
  AuthenticatedValuationsIndexRouteImport.update({
    id: '/valuations/',
    path: '/valuations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedValuationEntriesIndexRoute =
  AuthenticatedValuationEntriesIndexRouteImport.update({
    id: '/valuation-entries/',
    path: '/valuation-entries/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedV0IndexRoute = AuthenticatedV0IndexRouteImport.update({
  id: '/v0/',
  path: '/v0/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUnauthorizedIndexRoute =
  AuthenticatedUnauthorizedIndexRouteImport.update({
    id: '/unauthorized/',
    path: '/unauthorized/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransactionsIndexRoute =
  AuthenticatedTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaxesIndexRoute = AuthenticatedTaxesIndexRouteImport.update({
  id: '/taxes/',
  path: '/taxes/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTaxPenaltiesIndexRoute =
  AuthenticatedTaxPenaltiesIndexRouteImport.update({
    id: '/tax-penalties/',
    path: '/tax-penalties/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSyndicatesIndexRoute =
  AuthenticatedSyndicatesIndexRouteImport.update({
    id: '/syndicates/',
    path: '/syndicates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupportIndexRoute =
  AuthenticatedSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpvFeeDiscountsIndexRoute =
  AuthenticatedSpvFeeDiscountsIndexRouteImport.update({
    id: '/spv-fee-discounts/',
    path: '/spv-fee-discounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSkillsIndexRoute =
  AuthenticatedSkillsIndexRouteImport.update({
    id: '/skills/',
    path: '/skills/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSignatureLogsIndexRoute =
  AuthenticatedSignatureLogsIndexRouteImport.update({
    id: '/signature-logs/',
    path: '/signature-logs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSideLettersIndexRoute =
  AuthenticatedSideLettersIndexRouteImport.update({
    id: '/side-letters/',
    path: '/side-letters/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSellOrderRequestsIndexRoute =
  AuthenticatedSellOrderRequestsIndexRouteImport.update({
    id: '/sell-order-requests/',
    path: '/sell-order-requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSecurityIndexRoute =
  AuthenticatedSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSecondariesIndexRoute =
  AuthenticatedSecondariesIndexRouteImport.update({
    id: '/secondaries/',
    path: '/secondaries/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSearchIndexRoute =
  AuthenticatedSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSalesIndexRoute = AuthenticatedSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRewardsIndexRoute =
  AuthenticatedRewardsIndexRouteImport.update({
    id: '/rewards/',
    path: '/rewards/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRegulatoryFilingsIndexRoute =
  AuthenticatedRegulatoryFilingsIndexRouteImport.update({
    id: '/regulatory-filings/',
    path: '/regulatory-filings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQueueMonitorIndexRoute =
  AuthenticatedQueueMonitorIndexRouteImport.update({
    id: '/queue-monitor/',
    path: '/queue-monitor/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsPricingIndexRoute =
  AuthenticatedProductsPricingIndexRouteImport.update({
    id: '/products-pricing/',
    path: '/products-pricing/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPledgesIndexRoute =
  AuthenticatedPledgesIndexRouteImport.update({
    id: '/pledges/',
    path: '/pledges/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMigrationsIndexRoute =
  AuthenticatedMigrationsIndexRouteImport.update({
    id: '/migrations/',
    path: '/migrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeowBankingIndexRoute =
  AuthenticatedMeowBankingIndexRouteImport.update({
    id: '/meow-banking/',
    path: '/meow-banking/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembershipTransfersIndexRoute =
  AuthenticatedMembershipTransfersIndexRouteImport.update({
    id: '/membership-transfers/',
    path: '/membership-transfers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMcpKeysIndexRoute =
  AuthenticatedMcpKeysIndexRouteImport.update({
    id: '/mcp-keys/',
    path: '/mcp-keys/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMasterIndexRoute =
  AuthenticatedMasterIndexRouteImport.update({
    id: '/master/',
    path: '/master/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMailIndexRoute = AuthenticatedMailIndexRouteImport.update({
  id: '/mail/',
  path: '/mail/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLogsIndexRoute = AuthenticatedLogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLegalTemplatesIndexRoute =
  AuthenticatedLegalTemplatesIndexRouteImport.update({
    id: '/legal-templates/',
    path: '/legal-templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLegalDocumentsIndexRoute =
  AuthenticatedLegalDocumentsIndexRouteImport.update({
    id: '/legal-documents/',
    path: '/legal-documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLedgerIndexRoute =
  AuthenticatedLedgerIndexRouteImport.update({
    id: '/ledger/',
    path: '/ledger/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoiceRequestsIndexRoute =
  AuthenticatedInvoiceRequestsIndexRouteImport.update({
    id: '/invoice-requests/',
    path: '/invoice-requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoiceItemsIndexRoute =
  AuthenticatedInvoiceItemsIndexRouteImport.update({
    id: '/invoice-items/',
    path: '/invoice-items/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvestorUpdatesIndexRoute =
  AuthenticatedInvestorUpdatesIndexRouteImport.update({
    id: '/investor-updates/',
    path: '/investor-updates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvestorRecipientsIndexRoute =
  AuthenticatedInvestorRecipientsIndexRouteImport.update({
    id: '/investor-recipients/',
    path: '/investor-recipients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvestorNetworkIndexRoute =
  AuthenticatedInvestorNetworkIndexRouteImport.update({
    id: '/investor-network/',
    path: '/investor-network/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvestmentsIndexRoute =
  AuthenticatedInvestmentsIndexRouteImport.update({
    id: '/investments/',
    path: '/investments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntercomIndexRoute =
  AuthenticatedIntercomIndexRouteImport.update({
    id: '/intercom/',
    path: '/intercom/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncreaseBankingIndexRoute =
  AuthenticatedIncreaseBankingIndexRouteImport.update({
    id: '/increase-banking/',
    path: '/increase-banking/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIdentitiesIndexRoute =
  AuthenticatedIdentitiesIndexRouteImport.update({
    id: '/identities/',
    path: '/identities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGranolaIndexRoute =
  AuthenticatedGranolaIndexRouteImport.update({
    id: '/granola/',
    path: '/granola/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFundsIndexRoute = AuthenticatedFundsIndexRouteImport.update({
  id: '/funds/',
  path: '/funds/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFundraisingIndexRoute =
  AuthenticatedFundraisingIndexRouteImport.update({
    id: '/fundraising/',
    path: '/fundraising/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFundManagersIndexRoute =
  AuthenticatedFundManagersIndexRouteImport.update({
    id: '/fund-managers/',
    path: '/fund-managers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFundManagerNetworkIndexRoute =
  AuthenticatedFundManagerNetworkIndexRouteImport.update({
    id: '/fund-manager-network/',
    path: '/fund-manager-network/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinancialsIndexRoute =
  AuthenticatedFinancialsIndexRouteImport.update({
    id: '/financials/',
    path: '/financials/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesIndexRoute = AuthenticatedFilesIndexRouteImport.update({
  id: '/files/',
  path: '/files/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedbacksIndexRoute =
  AuthenticatedFeedbacksIndexRouteImport.update({
    id: '/feedbacks/',
    path: '/feedbacks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFaqsIndexRoute = AuthenticatedFaqsIndexRouteImport.update({
  id: '/faqs/',
  path: '/faqs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExternalRecipientsIndexRoute =
  AuthenticatedExternalRecipientsIndexRouteImport.update({
    id: '/external-recipients/',
    path: '/external-recipients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEscalationsIndexRoute =
  AuthenticatedEscalationsIndexRouteImport.update({
    id: '/escalations/',
    path: '/escalations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEreborBankingIndexRoute =
  AuthenticatedEreborBankingIndexRouteImport.update({
    id: '/erebor-banking/',
    path: '/erebor-banking/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntitiesIndexRoute =
  AuthenticatedEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmailsIndexRoute =
  AuthenticatedEmailsIndexRouteImport.update({
    id: '/emails/',
    path: '/emails/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmailTemplatesIndexRoute =
  AuthenticatedEmailTemplatesIndexRouteImport.update({
    id: '/email-templates/',
    path: '/email-templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDistributionsIndexRoute =
  AuthenticatedDistributionsIndexRouteImport.update({
    id: '/distributions/',
    path: '/distributions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDealsIndexRoute = AuthenticatedDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDealsWithUnitsIndexRoute =
  AuthenticatedDealsWithUnitsIndexRouteImport.update({
    id: '/deals-with-units/',
    path: '/deals-with-units/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCrmIndexRoute = AuthenticatedCrmIndexRouteImport.update({
  id: '/crm/',
  path: '/crm/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedComplianceIndexRoute =
  AuthenticatedComplianceIndexRouteImport.update({
    id: '/compliance/',
    path: '/compliance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClosesIndexRoute =
  AuthenticatedClosesIndexRouteImport.update({
    id: '/closes/',
    path: '/closes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCashAccountsIndexRoute =
  AuthenticatedCashAccountsIndexRouteImport.update({
    id: '/cash-accounts/',
    path: '/cash-accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCapitalCallsIndexRoute =
  AuthenticatedCapitalCallsIndexRouteImport.update({
    id: '/capital-calls/',
    path: '/capital-calls/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBrokerageAccountsIndexRoute =
  AuthenticatedBrokerageAccountsIndexRouteImport.update({
    id: '/brokerage-accounts/',
    path: '/brokerage-accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBrokerageAccountsAlpacaIndexRoute =
  AuthenticatedBrokerageAccountsAlpacaIndexRouteImport.update({
    id: '/brokerage-accounts-alpaca/',
    path: '/brokerage-accounts-alpaca/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlueSkyFeesIndexRoute =
  AuthenticatedBlueSkyFeesIndexRouteImport.update({
    id: '/blue-sky-fees/',
    path: '/blue-sky-fees/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBannersIndexRoute =
  AuthenticatedBannersIndexRouteImport.update({
    id: '/banners/',
    path: '/banners/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBankingIndexRoute =
  AuthenticatedBankingIndexRouteImport.update({
    id: '/banking/',
    path: '/banking/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBankingProvidersIndexRoute =
  AuthenticatedBankingProvidersIndexRouteImport.update({
    id: '/banking-providers/',
    path: '/banking-providers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasIndexRoute = AuthenticatedAtlasIndexRouteImport.update({
  id: '/atlas/',
  path: '/atlas/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: '/assets/',
    path: '/assets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsCleanupIndexRoute =
  AuthenticatedAssetsCleanupIndexRouteImport.update({
    id: '/assets-cleanup/',
    path: '/assets-cleanup/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetValuationsIndexRoute =
  AuthenticatedAssetValuationsIndexRouteImport.update({
    id: '/asset-valuations/',
    path: '/asset-valuations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArchiveRequestsIndexRoute =
  AuthenticatedArchiveRequestsIndexRouteImport.update({
    id: '/archive-requests/',
    path: '/archive-requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppManagementIndexRoute =
  AuthenticatedAppManagementIndexRouteImport.update({
    id: '/app-management/',
    path: '/app-management/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApiAccessManagerIndexRoute =
  AuthenticatedApiAccessManagerIndexRouteImport.update({
    id: '/api-access-manager/',
    path: '/api-access-manager/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAllocationsBankingIndexRoute =
  AuthenticatedAllocationsBankingIndexRouteImport.update({
    id: '/allocations-banking/',
    path: '/allocations-banking/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiStudioIndexRoute =
  AuthenticatedAiStudioIndexRouteImport.update({
    id: '/ai-studio/',
    path: '/ai-studio/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentsIndexRoute =
  AuthenticatedAgentsIndexRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdministratorsIndexRoute =
  AuthenticatedAdministratorsIndexRouteImport.update({
    id: '/administrators/',
    path: '/administrators/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActivitiesIndexRoute =
  AuthenticatedActivitiesIndexRouteImport.update({
    id: '/activities/',
    path: '/activities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsIndexRoute =
  AuthenticatedAccountsIndexRouteImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccessManagementIndexRoute =
  AuthenticatedAccessManagementIndexRouteImport.update({
    id: '/access-management/',
    path: '/access-management/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiStudioChatIdRoute =
  AuthenticatedAiStudioChatIdRouteImport.update({
    id: '/ai-studio/$chatId',
    path: '/ai-studio/$chatId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsSpendByProductRoute =
  AuthenticatedAccountsSpendByProductRouteImport.update({
    id: '/accounts/spend-by-product',
    path: '/accounts/spend-by-product',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsSpendRoute =
  AuthenticatedAccountsSpendRouteImport.update({
    id: '/accounts/spend',
    path: '/accounts/spend',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedValuationsIdIndexRoute =
  AuthenticatedValuationsIdIndexRouteImport.update({
    id: '/valuations/$id/',
    path: '/valuations/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaxesMetricsIndexRoute =
  AuthenticatedTaxesMetricsIndexRouteImport.update({
    id: '/taxes/metrics/',
    path: '/taxes/metrics/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaxesDiscrepanciesIndexRoute =
  AuthenticatedTaxesDiscrepanciesIndexRouteImport.update({
    id: '/taxes/discrepancies/',
    path: '/taxes/discrepancies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupportSearchIndexRoute =
  AuthenticatedSupportSearchIndexRouteImport.update({
    id: '/support/search/',
    path: '/support/search/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedScriptsGenerateLegalDocsIndexRoute =
  AuthenticatedScriptsGenerateLegalDocsIndexRouteImport.update({
    id: '/scripts/generate-legal-docs/',
    path: '/scripts/generate-legal-docs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSalesPulseIndexRoute =
  AuthenticatedSalesPulseIndexRouteImport.update({
    id: '/sales/pulse/',
    path: '/sales/pulse/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsPricingIdIndexRoute =
  AuthenticatedProductsPricingIdIndexRouteImport.update({
    id: '/products-pricing/$id/',
    path: '/products-pricing/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPledgesIdIndexRoute =
  AuthenticatedPledgesIdIndexRouteImport.update({
    id: '/pledges/$id/',
    path: '/pledges/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsIdIndexRoute =
  AuthenticatedOrganizationsIdIndexRouteImport.update({
    id: '/organizations/$id/',
    path: '/organizations/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeowBankingEntityIdIndexRoute =
  AuthenticatedMeowBankingEntityIdIndexRouteImport.update({
    id: '/meow-banking/$entityId/',
    path: '/meow-banking/$entityId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMembershipTransfersIdIndexRoute =
  AuthenticatedMembershipTransfersIdIndexRouteImport.update({
    id: '/membership-transfers/$id/',
    path: '/membership-transfers/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLogsTrackIndexRoute =
  AuthenticatedLogsTrackIndexRouteImport.update({
    id: '/logs/track/',
    path: '/logs/track/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLogsApiIndexRoute =
  AuthenticatedLogsApiIndexRouteImport.update({
    id: '/logs/api/',
    path: '/logs/api/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvestmentsIdIndexRoute =
  AuthenticatedInvestmentsIdIndexRouteImport.update({
    id: '/investments/$id/',
    path: '/investments/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncreaseBankingAccountIdIndexRoute =
  AuthenticatedIncreaseBankingAccountIdIndexRouteImport.update({
    id: '/increase-banking/$accountId/',
    path: '/increase-banking/$accountId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIdentitiesIdIndexRoute =
  AuthenticatedIdentitiesIdIndexRouteImport.update({
    id: '/identities/$id/',
    path: '/identities/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFundraisingPledgesIndexRoute =
  AuthenticatedFundraisingPledgesIndexRouteImport.update({
    id: '/fundraising/pledges/',
    path: '/fundraising/pledges/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFundraisingEmailsIndexRoute =
  AuthenticatedFundraisingEmailsIndexRouteImport.update({
    id: '/fundraising/emails/',
    path: '/fundraising/emails/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFundraisingDataroomIndexRoute =
  AuthenticatedFundraisingDataroomIndexRouteImport.update({
    id: '/fundraising/dataroom/',
    path: '/fundraising/dataroom/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFundraisingContactsIndexRoute =
  AuthenticatedFundraisingContactsIndexRouteImport.update({
    id: '/fundraising/contacts/',
    path: '/fundraising/contacts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinancialsSheetsIndexRoute =
  AuthenticatedFinancialsSheetsIndexRouteImport.update({
    id: '/financials/sheets/',
    path: '/financials/sheets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntitiesIdIndexRoute =
  AuthenticatedEntitiesIdIndexRouteImport.update({
    id: '/entities/$id/',
    path: '/entities/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDistributionsWiresIndexRoute =
  AuthenticatedDistributionsWiresIndexRouteImport.update({
    id: '/distributions/wires/',
    path: '/distributions/wires/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDistributionsIdIndexRoute =
  AuthenticatedDistributionsIdIndexRouteImport.update({
    id: '/distributions/$id/',
    path: '/distributions/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDealsBulkUploadIndexRoute =
  AuthenticatedDealsBulkUploadIndexRouteImport.update({
    id: '/deals/bulk-upload/',
    path: '/deals/bulk-upload/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDealsIdIndexRoute =
  AuthenticatedDealsIdIndexRouteImport.update({
    id: '/deals/$id/',
    path: '/deals/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceBviIndexRoute =
  AuthenticatedComplianceBviIndexRouteImport.update({
    id: '/compliance/bvi/',
    path: '/compliance/bvi/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceIdIndexRoute =
  AuthenticatedComplianceIdIndexRouteImport.update({
    id: '/compliance/$id/',
    path: '/compliance/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIdIndexRoute =
  AuthenticatedCompaniesIdIndexRouteImport.update({
    id: '/companies/$id/',
    path: '/companies/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClosesIdIndexRoute =
  AuthenticatedClosesIdIndexRouteImport.update({
    id: '/closes/$id/',
    path: '/closes/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatBugsIndexRoute =
  AuthenticatedChatBugsIndexRouteImport.update({
    id: '/chat/bugs/',
    path: '/chat/bugs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatIdIndexRoute =
  AuthenticatedChatIdIndexRouteImport.update({
    id: '/chat/$id/',
    path: '/chat/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCapitalCallsIdIndexRoute =
  AuthenticatedCapitalCallsIdIndexRouteImport.update({
    id: '/capital-calls/$id/',
    path: '/capital-calls/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBankingIdIndexRoute =
  AuthenticatedBankingIdIndexRouteImport.update({
    id: '/banking/$id/',
    path: '/banking/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasSuggestionsIndexRoute =
  AuthenticatedAtlasSuggestionsIndexRouteImport.update({
    id: '/atlas/suggestions/',
    path: '/atlas/suggestions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasPulseIndexRoute =
  AuthenticatedAtlasPulseIndexRouteImport.update({
    id: '/atlas/pulse/',
    path: '/atlas/pulse/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasOverviewIndexRoute =
  AuthenticatedAtlasOverviewIndexRouteImport.update({
    id: '/atlas/overview/',
    path: '/atlas/overview/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasDocumentationIndexRoute =
  AuthenticatedAtlasDocumentationIndexRouteImport.update({
    id: '/atlas/documentation/',
    path: '/atlas/documentation/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasDepartmentIndexRoute =
  AuthenticatedAtlasDepartmentIndexRouteImport.update({
    id: '/atlas/$department/',
    path: '/atlas/$department/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsIdIndexRoute =
  AuthenticatedAssetsIdIndexRouteImport.update({
    id: '/assets/$id/',
    path: '/assets/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiStudioSettingsIndexRoute =
  AuthenticatedAiStudioSettingsIndexRouteImport.update({
    id: '/ai-studio/settings/',
    path: '/ai-studio/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsIdIndexRoute =
  AuthenticatedAccountsIdIndexRouteImport.update({
    id: '/accounts/$id/',
    path: '/accounts/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinancialsSheetsSheetIdRoute =
  AuthenticatedFinancialsSheetsSheetIdRouteImport.update({
    id: '/financials/sheets/$sheetId',
    path: '/financials/sheets/$sheetId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasSuggestionsIdRoute =
  AuthenticatedAtlasSuggestionsIdRouteImport.update({
    id: '/atlas/suggestions/$id',
    path: '/atlas/suggestions/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAtlasDepartmentPageRoute =
  AuthenticatedAtlasDepartmentPageRouteImport.update({
    id: '/atlas/$department/$page',
    path: '/atlas/$department/$page',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute =
  AuthenticatedTaxesDiscrepanciesTax_yearIndexRouteImport.update({
    id: '/taxes/discrepancies/$tax_year/',
    path: '/taxes/discrepancies/$tax_year/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaxesEntity_idTax_yearIndexRoute =
  AuthenticatedTaxesEntity_idTax_yearIndexRouteImport.update({
    id: '/taxes/$entity_id/$tax_year/',
    path: '/taxes/$entity_id/$tax_year/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSyndicatesIdAdminIndexRoute =
  AuthenticatedSyndicatesIdAdminIndexRouteImport.update({
    id: '/syndicates/$id/admin/',
    path: '/syndicates/$id/admin/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLedgerAccountsIdIndexRoute =
  AuthenticatedLedgerAccountsIdIndexRouteImport.update({
    id: '/ledger/accounts/$id/',
    path: '/ledger/accounts/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDistributionsIdDistributionsEventsIndexRoute =
  AuthenticatedDistributionsIdDistributionsEventsIndexRouteImport.update({
    id: '/distributions/$id/distributions-events/',
    path: '/distributions/$id/distributions-events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceBviManualIndexRoute =
  AuthenticatedComplianceBviManualIndexRouteImport.update({
    id: '/compliance/bvi/manual/',
    path: '/compliance/bvi/manual/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceBviFormationsIndexRoute =
  AuthenticatedComplianceBviFormationsIndexRouteImport.update({
    id: '/compliance/bvi/formations/',
    path: '/compliance/bvi/formations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute =
  AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRouteImport.update(
    {
      id: '/distributions/$id/distributions-events/$eventId/',
      path: '/distributions/$id/distributions-events/$eventId/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedComplianceBviFormationsIdIndexRoute =
  AuthenticatedComplianceBviFormationsIdIndexRouteImport.update({
    id: '/compliance/bvi/formations/$id/',
    path: '/compliance/bvi/formations/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/accounts/spend': typeof AuthenticatedAccountsSpendRoute
  '/accounts/spend-by-product': typeof AuthenticatedAccountsSpendByProductRoute
  '/ai-studio/$chatId': typeof AuthenticatedAiStudioChatIdRoute
  '/access-management/': typeof AuthenticatedAccessManagementIndexRoute
  '/accounts/': typeof AuthenticatedAccountsIndexRoute
  '/activities/': typeof AuthenticatedActivitiesIndexRoute
  '/administrators/': typeof AuthenticatedAdministratorsIndexRoute
  '/agents/': typeof AuthenticatedAgentsIndexRoute
  '/ai-studio/': typeof AuthenticatedAiStudioIndexRoute
  '/allocations-banking/': typeof AuthenticatedAllocationsBankingIndexRoute
  '/api-access-manager/': typeof AuthenticatedApiAccessManagerIndexRoute
  '/app-management/': typeof AuthenticatedAppManagementIndexRoute
  '/archive-requests/': typeof AuthenticatedArchiveRequestsIndexRoute
  '/asset-valuations/': typeof AuthenticatedAssetValuationsIndexRoute
  '/assets-cleanup/': typeof AuthenticatedAssetsCleanupIndexRoute
  '/assets/': typeof AuthenticatedAssetsIndexRoute
  '/atlas/': typeof AuthenticatedAtlasIndexRoute
  '/banking-providers/': typeof AuthenticatedBankingProvidersIndexRoute
  '/banking/': typeof AuthenticatedBankingIndexRoute
  '/banners/': typeof AuthenticatedBannersIndexRoute
  '/blue-sky-fees/': typeof AuthenticatedBlueSkyFeesIndexRoute
  '/brokerage-accounts-alpaca/': typeof AuthenticatedBrokerageAccountsAlpacaIndexRoute
  '/brokerage-accounts/': typeof AuthenticatedBrokerageAccountsIndexRoute
  '/capital-calls/': typeof AuthenticatedCapitalCallsIndexRoute
  '/cash-accounts/': typeof AuthenticatedCashAccountsIndexRoute
  '/chat/': typeof AuthenticatedChatIndexRoute
  '/closes/': typeof AuthenticatedClosesIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/compliance/': typeof AuthenticatedComplianceIndexRoute
  '/crm/': typeof AuthenticatedCrmIndexRoute
  '/deals-with-units/': typeof AuthenticatedDealsWithUnitsIndexRoute
  '/deals/': typeof AuthenticatedDealsIndexRoute
  '/distributions/': typeof AuthenticatedDistributionsIndexRoute
  '/email-templates/': typeof AuthenticatedEmailTemplatesIndexRoute
  '/emails/': typeof AuthenticatedEmailsIndexRoute
  '/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/erebor-banking/': typeof AuthenticatedEreborBankingIndexRoute
  '/escalations/': typeof AuthenticatedEscalationsIndexRoute
  '/external-recipients/': typeof AuthenticatedExternalRecipientsIndexRoute
  '/faqs/': typeof AuthenticatedFaqsIndexRoute
  '/feedbacks/': typeof AuthenticatedFeedbacksIndexRoute
  '/files/': typeof AuthenticatedFilesIndexRoute
  '/financials/': typeof AuthenticatedFinancialsIndexRoute
  '/fund-manager-network/': typeof AuthenticatedFundManagerNetworkIndexRoute
  '/fund-managers/': typeof AuthenticatedFundManagersIndexRoute
  '/fundraising/': typeof AuthenticatedFundraisingIndexRoute
  '/funds/': typeof AuthenticatedFundsIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/granola/': typeof AuthenticatedGranolaIndexRoute
  '/identities/': typeof AuthenticatedIdentitiesIndexRoute
  '/increase-banking/': typeof AuthenticatedIncreaseBankingIndexRoute
  '/intercom/': typeof AuthenticatedIntercomIndexRoute
  '/investments/': typeof AuthenticatedInvestmentsIndexRoute
  '/investor-network/': typeof AuthenticatedInvestorNetworkIndexRoute
  '/investor-recipients/': typeof AuthenticatedInvestorRecipientsIndexRoute
  '/investor-updates/': typeof AuthenticatedInvestorUpdatesIndexRoute
  '/invoice-items/': typeof AuthenticatedInvoiceItemsIndexRoute
  '/invoice-requests/': typeof AuthenticatedInvoiceRequestsIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/ledger/': typeof AuthenticatedLedgerIndexRoute
  '/legal-documents/': typeof AuthenticatedLegalDocumentsIndexRoute
  '/legal-templates/': typeof AuthenticatedLegalTemplatesIndexRoute
  '/logs/': typeof AuthenticatedLogsIndexRoute
  '/mail/': typeof AuthenticatedMailIndexRoute
  '/master/': typeof AuthenticatedMasterIndexRoute
  '/mcp-keys/': typeof AuthenticatedMcpKeysIndexRoute
  '/membership-transfers/': typeof AuthenticatedMembershipTransfersIndexRoute
  '/meow-banking/': typeof AuthenticatedMeowBankingIndexRoute
  '/migrations/': typeof AuthenticatedMigrationsIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/pledges/': typeof AuthenticatedPledgesIndexRoute
  '/products-pricing/': typeof AuthenticatedProductsPricingIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/queue-monitor/': typeof AuthenticatedQueueMonitorIndexRoute
  '/regulatory-filings/': typeof AuthenticatedRegulatoryFilingsIndexRoute
  '/rewards/': typeof AuthenticatedRewardsIndexRoute
  '/sales/': typeof AuthenticatedSalesIndexRoute
  '/search/': typeof AuthenticatedSearchIndexRoute
  '/secondaries/': typeof AuthenticatedSecondariesIndexRoute
  '/security/': typeof AuthenticatedSecurityIndexRoute
  '/sell-order-requests/': typeof AuthenticatedSellOrderRequestsIndexRoute
  '/side-letters/': typeof AuthenticatedSideLettersIndexRoute
  '/signature-logs/': typeof AuthenticatedSignatureLogsIndexRoute
  '/skills/': typeof AuthenticatedSkillsIndexRoute
  '/spv-fee-discounts/': typeof AuthenticatedSpvFeeDiscountsIndexRoute
  '/support/': typeof AuthenticatedSupportIndexRoute
  '/syndicates/': typeof AuthenticatedSyndicatesIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/tax-penalties/': typeof AuthenticatedTaxPenaltiesIndexRoute
  '/taxes/': typeof AuthenticatedTaxesIndexRoute
  '/transactions/': typeof AuthenticatedTransactionsIndexRoute
  '/unauthorized/': typeof AuthenticatedUnauthorizedIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/v0/': typeof AuthenticatedV0IndexRoute
  '/valuation-entries/': typeof AuthenticatedValuationEntriesIndexRoute
  '/valuations/': typeof AuthenticatedValuationsIndexRoute
  '/vendors/': typeof AuthenticatedVendorsIndexRoute
  '/wire-request-escalations/': typeof AuthenticatedWireRequestEscalationsIndexRoute
  '/wire-requests/': typeof AuthenticatedWireRequestsIndexRoute
  '/atlas/$department/$page': typeof AuthenticatedAtlasDepartmentPageRoute
  '/atlas/suggestions/$id': typeof AuthenticatedAtlasSuggestionsIdRoute
  '/financials/sheets/$sheetId': typeof AuthenticatedFinancialsSheetsSheetIdRoute
  '/accounts/$id/': typeof AuthenticatedAccountsIdIndexRoute
  '/ai-studio/settings/': typeof AuthenticatedAiStudioSettingsIndexRoute
  '/assets/$id/': typeof AuthenticatedAssetsIdIndexRoute
  '/atlas/$department/': typeof AuthenticatedAtlasDepartmentIndexRoute
  '/atlas/documentation/': typeof AuthenticatedAtlasDocumentationIndexRoute
  '/atlas/overview/': typeof AuthenticatedAtlasOverviewIndexRoute
  '/atlas/pulse/': typeof AuthenticatedAtlasPulseIndexRoute
  '/atlas/suggestions/': typeof AuthenticatedAtlasSuggestionsIndexRoute
  '/banking/$id/': typeof AuthenticatedBankingIdIndexRoute
  '/capital-calls/$id/': typeof AuthenticatedCapitalCallsIdIndexRoute
  '/chat/$id/': typeof AuthenticatedChatIdIndexRoute
  '/chat/bugs/': typeof AuthenticatedChatBugsIndexRoute
  '/closes/$id/': typeof AuthenticatedClosesIdIndexRoute
  '/companies/$id/': typeof AuthenticatedCompaniesIdIndexRoute
  '/compliance/$id/': typeof AuthenticatedComplianceIdIndexRoute
  '/compliance/bvi/': typeof AuthenticatedComplianceBviIndexRoute
  '/deals/$id/': typeof AuthenticatedDealsIdIndexRoute
  '/deals/bulk-upload/': typeof AuthenticatedDealsBulkUploadIndexRoute
  '/distributions/$id/': typeof AuthenticatedDistributionsIdIndexRoute
  '/distributions/wires/': typeof AuthenticatedDistributionsWiresIndexRoute
  '/entities/$id/': typeof AuthenticatedEntitiesIdIndexRoute
  '/financials/sheets/': typeof AuthenticatedFinancialsSheetsIndexRoute
  '/fundraising/contacts/': typeof AuthenticatedFundraisingContactsIndexRoute
  '/fundraising/dataroom/': typeof AuthenticatedFundraisingDataroomIndexRoute
  '/fundraising/emails/': typeof AuthenticatedFundraisingEmailsIndexRoute
  '/fundraising/pledges/': typeof AuthenticatedFundraisingPledgesIndexRoute
  '/identities/$id/': typeof AuthenticatedIdentitiesIdIndexRoute
  '/increase-banking/$accountId/': typeof AuthenticatedIncreaseBankingAccountIdIndexRoute
  '/investments/$id/': typeof AuthenticatedInvestmentsIdIndexRoute
  '/logs/api/': typeof AuthenticatedLogsApiIndexRoute
  '/logs/track/': typeof AuthenticatedLogsTrackIndexRoute
  '/membership-transfers/$id/': typeof AuthenticatedMembershipTransfersIdIndexRoute
  '/meow-banking/$entityId/': typeof AuthenticatedMeowBankingEntityIdIndexRoute
  '/organizations/$id/': typeof AuthenticatedOrganizationsIdIndexRoute
  '/pledges/$id/': typeof AuthenticatedPledgesIdIndexRoute
  '/products-pricing/$id/': typeof AuthenticatedProductsPricingIdIndexRoute
  '/sales/pulse/': typeof AuthenticatedSalesPulseIndexRoute
  '/scripts/generate-legal-docs/': typeof AuthenticatedScriptsGenerateLegalDocsIndexRoute
  '/support/search/': typeof AuthenticatedSupportSearchIndexRoute
  '/taxes/discrepancies/': typeof AuthenticatedTaxesDiscrepanciesIndexRoute
  '/taxes/metrics/': typeof AuthenticatedTaxesMetricsIndexRoute
  '/valuations/$id/': typeof AuthenticatedValuationsIdIndexRoute
  '/compliance/bvi/formations/': typeof AuthenticatedComplianceBviFormationsIndexRoute
  '/compliance/bvi/manual/': typeof AuthenticatedComplianceBviManualIndexRoute
  '/distributions/$id/distributions-events/': typeof AuthenticatedDistributionsIdDistributionsEventsIndexRoute
  '/ledger/accounts/$id/': typeof AuthenticatedLedgerAccountsIdIndexRoute
  '/syndicates/$id/admin/': typeof AuthenticatedSyndicatesIdAdminIndexRoute
  '/taxes/$entity_id/$tax_year/': typeof AuthenticatedTaxesEntity_idTax_yearIndexRoute
  '/taxes/discrepancies/$tax_year/': typeof AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute
  '/compliance/bvi/formations/$id/': typeof AuthenticatedComplianceBviFormationsIdIndexRoute
  '/distributions/$id/distributions-events/$eventId/': typeof AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/accounts/spend': typeof AuthenticatedAccountsSpendRoute
  '/accounts/spend-by-product': typeof AuthenticatedAccountsSpendByProductRoute
  '/ai-studio/$chatId': typeof AuthenticatedAiStudioChatIdRoute
  '/access-management': typeof AuthenticatedAccessManagementIndexRoute
  '/accounts': typeof AuthenticatedAccountsIndexRoute
  '/activities': typeof AuthenticatedActivitiesIndexRoute
  '/administrators': typeof AuthenticatedAdministratorsIndexRoute
  '/agents': typeof AuthenticatedAgentsIndexRoute
  '/ai-studio': typeof AuthenticatedAiStudioIndexRoute
  '/allocations-banking': typeof AuthenticatedAllocationsBankingIndexRoute
  '/api-access-manager': typeof AuthenticatedApiAccessManagerIndexRoute
  '/app-management': typeof AuthenticatedAppManagementIndexRoute
  '/archive-requests': typeof AuthenticatedArchiveRequestsIndexRoute
  '/asset-valuations': typeof AuthenticatedAssetValuationsIndexRoute
  '/assets-cleanup': typeof AuthenticatedAssetsCleanupIndexRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/atlas': typeof AuthenticatedAtlasIndexRoute
  '/banking-providers': typeof AuthenticatedBankingProvidersIndexRoute
  '/banking': typeof AuthenticatedBankingIndexRoute
  '/banners': typeof AuthenticatedBannersIndexRoute
  '/blue-sky-fees': typeof AuthenticatedBlueSkyFeesIndexRoute
  '/brokerage-accounts-alpaca': typeof AuthenticatedBrokerageAccountsAlpacaIndexRoute
  '/brokerage-accounts': typeof AuthenticatedBrokerageAccountsIndexRoute
  '/capital-calls': typeof AuthenticatedCapitalCallsIndexRoute
  '/cash-accounts': typeof AuthenticatedCashAccountsIndexRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/closes': typeof AuthenticatedClosesIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/compliance': typeof AuthenticatedComplianceIndexRoute
  '/crm': typeof AuthenticatedCrmIndexRoute
  '/deals-with-units': typeof AuthenticatedDealsWithUnitsIndexRoute
  '/deals': typeof AuthenticatedDealsIndexRoute
  '/distributions': typeof AuthenticatedDistributionsIndexRoute
  '/email-templates': typeof AuthenticatedEmailTemplatesIndexRoute
  '/emails': typeof AuthenticatedEmailsIndexRoute
  '/entities': typeof AuthenticatedEntitiesIndexRoute
  '/erebor-banking': typeof AuthenticatedEreborBankingIndexRoute
  '/escalations': typeof AuthenticatedEscalationsIndexRoute
  '/external-recipients': typeof AuthenticatedExternalRecipientsIndexRoute
  '/faqs': typeof AuthenticatedFaqsIndexRoute
  '/feedbacks': typeof AuthenticatedFeedbacksIndexRoute
  '/files': typeof AuthenticatedFilesIndexRoute
  '/financials': typeof AuthenticatedFinancialsIndexRoute
  '/fund-manager-network': typeof AuthenticatedFundManagerNetworkIndexRoute
  '/fund-managers': typeof AuthenticatedFundManagersIndexRoute
  '/fundraising': typeof AuthenticatedFundraisingIndexRoute
  '/funds': typeof AuthenticatedFundsIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/granola': typeof AuthenticatedGranolaIndexRoute
  '/identities': typeof AuthenticatedIdentitiesIndexRoute
  '/increase-banking': typeof AuthenticatedIncreaseBankingIndexRoute
  '/intercom': typeof AuthenticatedIntercomIndexRoute
  '/investments': typeof AuthenticatedInvestmentsIndexRoute
  '/investor-network': typeof AuthenticatedInvestorNetworkIndexRoute
  '/investor-recipients': typeof AuthenticatedInvestorRecipientsIndexRoute
  '/investor-updates': typeof AuthenticatedInvestorUpdatesIndexRoute
  '/invoice-items': typeof AuthenticatedInvoiceItemsIndexRoute
  '/invoice-requests': typeof AuthenticatedInvoiceRequestsIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/ledger': typeof AuthenticatedLedgerIndexRoute
  '/legal-documents': typeof AuthenticatedLegalDocumentsIndexRoute
  '/legal-templates': typeof AuthenticatedLegalTemplatesIndexRoute
  '/logs': typeof AuthenticatedLogsIndexRoute
  '/mail': typeof AuthenticatedMailIndexRoute
  '/master': typeof AuthenticatedMasterIndexRoute
  '/mcp-keys': typeof AuthenticatedMcpKeysIndexRoute
  '/membership-transfers': typeof AuthenticatedMembershipTransfersIndexRoute
  '/meow-banking': typeof AuthenticatedMeowBankingIndexRoute
  '/migrations': typeof AuthenticatedMigrationsIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/pledges': typeof AuthenticatedPledgesIndexRoute
  '/products-pricing': typeof AuthenticatedProductsPricingIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/queue-monitor': typeof AuthenticatedQueueMonitorIndexRoute
  '/regulatory-filings': typeof AuthenticatedRegulatoryFilingsIndexRoute
  '/rewards': typeof AuthenticatedRewardsIndexRoute
  '/sales': typeof AuthenticatedSalesIndexRoute
  '/search': typeof AuthenticatedSearchIndexRoute
  '/secondaries': typeof AuthenticatedSecondariesIndexRoute
  '/security': typeof AuthenticatedSecurityIndexRoute
  '/sell-order-requests': typeof AuthenticatedSellOrderRequestsIndexRoute
  '/side-letters': typeof AuthenticatedSideLettersIndexRoute
  '/signature-logs': typeof AuthenticatedSignatureLogsIndexRoute
  '/skills': typeof AuthenticatedSkillsIndexRoute
  '/spv-fee-discounts': typeof AuthenticatedSpvFeeDiscountsIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
  '/syndicates': typeof AuthenticatedSyndicatesIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/tax-penalties': typeof AuthenticatedTaxPenaltiesIndexRoute
  '/taxes': typeof AuthenticatedTaxesIndexRoute
  '/transactions': typeof AuthenticatedTransactionsIndexRoute
  '/unauthorized': typeof AuthenticatedUnauthorizedIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/v0': typeof AuthenticatedV0IndexRoute
  '/valuation-entries': typeof AuthenticatedValuationEntriesIndexRoute
  '/valuations': typeof AuthenticatedValuationsIndexRoute
  '/vendors': typeof AuthenticatedVendorsIndexRoute
  '/wire-request-escalations': typeof AuthenticatedWireRequestEscalationsIndexRoute
  '/wire-requests': typeof AuthenticatedWireRequestsIndexRoute
  '/atlas/$department/$page': typeof AuthenticatedAtlasDepartmentPageRoute
  '/atlas/suggestions/$id': typeof AuthenticatedAtlasSuggestionsIdRoute
  '/financials/sheets/$sheetId': typeof AuthenticatedFinancialsSheetsSheetIdRoute
  '/accounts/$id': typeof AuthenticatedAccountsIdIndexRoute
  '/ai-studio/settings': typeof AuthenticatedAiStudioSettingsIndexRoute
  '/assets/$id': typeof AuthenticatedAssetsIdIndexRoute
  '/atlas/$department': typeof AuthenticatedAtlasDepartmentIndexRoute
  '/atlas/documentation': typeof AuthenticatedAtlasDocumentationIndexRoute
  '/atlas/overview': typeof AuthenticatedAtlasOverviewIndexRoute
  '/atlas/pulse': typeof AuthenticatedAtlasPulseIndexRoute
  '/atlas/suggestions': typeof AuthenticatedAtlasSuggestionsIndexRoute
  '/banking/$id': typeof AuthenticatedBankingIdIndexRoute
  '/capital-calls/$id': typeof AuthenticatedCapitalCallsIdIndexRoute
  '/chat/$id': typeof AuthenticatedChatIdIndexRoute
  '/chat/bugs': typeof AuthenticatedChatBugsIndexRoute
  '/closes/$id': typeof AuthenticatedClosesIdIndexRoute
  '/companies/$id': typeof AuthenticatedCompaniesIdIndexRoute
  '/compliance/$id': typeof AuthenticatedComplianceIdIndexRoute
  '/compliance/bvi': typeof AuthenticatedComplianceBviIndexRoute
  '/deals/$id': typeof AuthenticatedDealsIdIndexRoute
  '/deals/bulk-upload': typeof AuthenticatedDealsBulkUploadIndexRoute
  '/distributions/$id': typeof AuthenticatedDistributionsIdIndexRoute
  '/distributions/wires': typeof AuthenticatedDistributionsWiresIndexRoute
  '/entities/$id': typeof AuthenticatedEntitiesIdIndexRoute
  '/financials/sheets': typeof AuthenticatedFinancialsSheetsIndexRoute
  '/fundraising/contacts': typeof AuthenticatedFundraisingContactsIndexRoute
  '/fundraising/dataroom': typeof AuthenticatedFundraisingDataroomIndexRoute
  '/fundraising/emails': typeof AuthenticatedFundraisingEmailsIndexRoute
  '/fundraising/pledges': typeof AuthenticatedFundraisingPledgesIndexRoute
  '/identities/$id': typeof AuthenticatedIdentitiesIdIndexRoute
  '/increase-banking/$accountId': typeof AuthenticatedIncreaseBankingAccountIdIndexRoute
  '/investments/$id': typeof AuthenticatedInvestmentsIdIndexRoute
  '/logs/api': typeof AuthenticatedLogsApiIndexRoute
  '/logs/track': typeof AuthenticatedLogsTrackIndexRoute
  '/membership-transfers/$id': typeof AuthenticatedMembershipTransfersIdIndexRoute
  '/meow-banking/$entityId': typeof AuthenticatedMeowBankingEntityIdIndexRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdIndexRoute
  '/pledges/$id': typeof AuthenticatedPledgesIdIndexRoute
  '/products-pricing/$id': typeof AuthenticatedProductsPricingIdIndexRoute
  '/sales/pulse': typeof AuthenticatedSalesPulseIndexRoute
  '/scripts/generate-legal-docs': typeof AuthenticatedScriptsGenerateLegalDocsIndexRoute
  '/support/search': typeof AuthenticatedSupportSearchIndexRoute
  '/taxes/discrepancies': typeof AuthenticatedTaxesDiscrepanciesIndexRoute
  '/taxes/metrics': typeof AuthenticatedTaxesMetricsIndexRoute
  '/valuations/$id': typeof AuthenticatedValuationsIdIndexRoute
  '/compliance/bvi/formations': typeof AuthenticatedComplianceBviFormationsIndexRoute
  '/compliance/bvi/manual': typeof AuthenticatedComplianceBviManualIndexRoute
  '/distributions/$id/distributions-events': typeof AuthenticatedDistributionsIdDistributionsEventsIndexRoute
  '/ledger/accounts/$id': typeof AuthenticatedLedgerAccountsIdIndexRoute
  '/syndicates/$id/admin': typeof AuthenticatedSyndicatesIdAdminIndexRoute
  '/taxes/$entity_id/$tax_year': typeof AuthenticatedTaxesEntity_idTax_yearIndexRoute
  '/taxes/discrepancies/$tax_year': typeof AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute
  '/compliance/bvi/formations/$id': typeof AuthenticatedComplianceBviFormationsIdIndexRoute
  '/distributions/$id/distributions-events/$eventId': typeof AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/accounts/spend': typeof AuthenticatedAccountsSpendRoute
  '/_authenticated/accounts/spend-by-product': typeof AuthenticatedAccountsSpendByProductRoute
  '/_authenticated/ai-studio/$chatId': typeof AuthenticatedAiStudioChatIdRoute
  '/_authenticated/access-management/': typeof AuthenticatedAccessManagementIndexRoute
  '/_authenticated/accounts/': typeof AuthenticatedAccountsIndexRoute
  '/_authenticated/activities/': typeof AuthenticatedActivitiesIndexRoute
  '/_authenticated/administrators/': typeof AuthenticatedAdministratorsIndexRoute
  '/_authenticated/agents/': typeof AuthenticatedAgentsIndexRoute
  '/_authenticated/ai-studio/': typeof AuthenticatedAiStudioIndexRoute
  '/_authenticated/allocations-banking/': typeof AuthenticatedAllocationsBankingIndexRoute
  '/_authenticated/api-access-manager/': typeof AuthenticatedApiAccessManagerIndexRoute
  '/_authenticated/app-management/': typeof AuthenticatedAppManagementIndexRoute
  '/_authenticated/archive-requests/': typeof AuthenticatedArchiveRequestsIndexRoute
  '/_authenticated/asset-valuations/': typeof AuthenticatedAssetValuationsIndexRoute
  '/_authenticated/assets-cleanup/': typeof AuthenticatedAssetsCleanupIndexRoute
  '/_authenticated/assets/': typeof AuthenticatedAssetsIndexRoute
  '/_authenticated/atlas/': typeof AuthenticatedAtlasIndexRoute
  '/_authenticated/banking-providers/': typeof AuthenticatedBankingProvidersIndexRoute
  '/_authenticated/banking/': typeof AuthenticatedBankingIndexRoute
  '/_authenticated/banners/': typeof AuthenticatedBannersIndexRoute
  '/_authenticated/blue-sky-fees/': typeof AuthenticatedBlueSkyFeesIndexRoute
  '/_authenticated/brokerage-accounts-alpaca/': typeof AuthenticatedBrokerageAccountsAlpacaIndexRoute
  '/_authenticated/brokerage-accounts/': typeof AuthenticatedBrokerageAccountsIndexRoute
  '/_authenticated/capital-calls/': typeof AuthenticatedCapitalCallsIndexRoute
  '/_authenticated/cash-accounts/': typeof AuthenticatedCashAccountsIndexRoute
  '/_authenticated/chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/closes/': typeof AuthenticatedClosesIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/compliance/': typeof AuthenticatedComplianceIndexRoute
  '/_authenticated/crm/': typeof AuthenticatedCrmIndexRoute
  '/_authenticated/deals-with-units/': typeof AuthenticatedDealsWithUnitsIndexRoute
  '/_authenticated/deals/': typeof AuthenticatedDealsIndexRoute
  '/_authenticated/distributions/': typeof AuthenticatedDistributionsIndexRoute
  '/_authenticated/email-templates/': typeof AuthenticatedEmailTemplatesIndexRoute
  '/_authenticated/emails/': typeof AuthenticatedEmailsIndexRoute
  '/_authenticated/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/_authenticated/erebor-banking/': typeof AuthenticatedEreborBankingIndexRoute
  '/_authenticated/escalations/': typeof AuthenticatedEscalationsIndexRoute
  '/_authenticated/external-recipients/': typeof AuthenticatedExternalRecipientsIndexRoute
  '/_authenticated/faqs/': typeof AuthenticatedFaqsIndexRoute
  '/_authenticated/feedbacks/': typeof AuthenticatedFeedbacksIndexRoute
  '/_authenticated/files/': typeof AuthenticatedFilesIndexRoute
  '/_authenticated/financials/': typeof AuthenticatedFinancialsIndexRoute
  '/_authenticated/fund-manager-network/': typeof AuthenticatedFundManagerNetworkIndexRoute
  '/_authenticated/fund-managers/': typeof AuthenticatedFundManagersIndexRoute
  '/_authenticated/fundraising/': typeof AuthenticatedFundraisingIndexRoute
  '/_authenticated/funds/': typeof AuthenticatedFundsIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/granola/': typeof AuthenticatedGranolaIndexRoute
  '/_authenticated/identities/': typeof AuthenticatedIdentitiesIndexRoute
  '/_authenticated/increase-banking/': typeof AuthenticatedIncreaseBankingIndexRoute
  '/_authenticated/intercom/': typeof AuthenticatedIntercomIndexRoute
  '/_authenticated/investments/': typeof AuthenticatedInvestmentsIndexRoute
  '/_authenticated/investor-network/': typeof AuthenticatedInvestorNetworkIndexRoute
  '/_authenticated/investor-recipients/': typeof AuthenticatedInvestorRecipientsIndexRoute
  '/_authenticated/investor-updates/': typeof AuthenticatedInvestorUpdatesIndexRoute
  '/_authenticated/invoice-items/': typeof AuthenticatedInvoiceItemsIndexRoute
  '/_authenticated/invoice-requests/': typeof AuthenticatedInvoiceRequestsIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/ledger/': typeof AuthenticatedLedgerIndexRoute
  '/_authenticated/legal-documents/': typeof AuthenticatedLegalDocumentsIndexRoute
  '/_authenticated/legal-templates/': typeof AuthenticatedLegalTemplatesIndexRoute
  '/_authenticated/logs/': typeof AuthenticatedLogsIndexRoute
  '/_authenticated/mail/': typeof AuthenticatedMailIndexRoute
  '/_authenticated/master/': typeof AuthenticatedMasterIndexRoute
  '/_authenticated/mcp-keys/': typeof AuthenticatedMcpKeysIndexRoute
  '/_authenticated/membership-transfers/': typeof AuthenticatedMembershipTransfersIndexRoute
  '/_authenticated/meow-banking/': typeof AuthenticatedMeowBankingIndexRoute
  '/_authenticated/migrations/': typeof AuthenticatedMigrationsIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/pledges/': typeof AuthenticatedPledgesIndexRoute
  '/_authenticated/products-pricing/': typeof AuthenticatedProductsPricingIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/queue-monitor/': typeof AuthenticatedQueueMonitorIndexRoute
  '/_authenticated/regulatory-filings/': typeof AuthenticatedRegulatoryFilingsIndexRoute
  '/_authenticated/rewards/': typeof AuthenticatedRewardsIndexRoute
  '/_authenticated/sales/': typeof AuthenticatedSalesIndexRoute
  '/_authenticated/search/': typeof AuthenticatedSearchIndexRoute
  '/_authenticated/secondaries/': typeof AuthenticatedSecondariesIndexRoute
  '/_authenticated/security/': typeof AuthenticatedSecurityIndexRoute
  '/_authenticated/sell-order-requests/': typeof AuthenticatedSellOrderRequestsIndexRoute
  '/_authenticated/side-letters/': typeof AuthenticatedSideLettersIndexRoute
  '/_authenticated/signature-logs/': typeof AuthenticatedSignatureLogsIndexRoute
  '/_authenticated/skills/': typeof AuthenticatedSkillsIndexRoute
  '/_authenticated/spv-fee-discounts/': typeof AuthenticatedSpvFeeDiscountsIndexRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexRoute
  '/_authenticated/syndicates/': typeof AuthenticatedSyndicatesIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/tax-penalties/': typeof AuthenticatedTaxPenaltiesIndexRoute
  '/_authenticated/taxes/': typeof AuthenticatedTaxesIndexRoute
  '/_authenticated/transactions/': typeof AuthenticatedTransactionsIndexRoute
  '/_authenticated/unauthorized/': typeof AuthenticatedUnauthorizedIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/v0/': typeof AuthenticatedV0IndexRoute
  '/_authenticated/valuation-entries/': typeof AuthenticatedValuationEntriesIndexRoute
  '/_authenticated/valuations/': typeof AuthenticatedValuationsIndexRoute
  '/_authenticated/vendors/': typeof AuthenticatedVendorsIndexRoute
  '/_authenticated/wire-request-escalations/': typeof AuthenticatedWireRequestEscalationsIndexRoute
  '/_authenticated/wire-requests/': typeof AuthenticatedWireRequestsIndexRoute
  '/_authenticated/atlas/$department/$page': typeof AuthenticatedAtlasDepartmentPageRoute
  '/_authenticated/atlas/suggestions/$id': typeof AuthenticatedAtlasSuggestionsIdRoute
  '/_authenticated/financials/sheets/$sheetId': typeof AuthenticatedFinancialsSheetsSheetIdRoute
  '/_authenticated/accounts/$id/': typeof AuthenticatedAccountsIdIndexRoute
  '/_authenticated/ai-studio/settings/': typeof AuthenticatedAiStudioSettingsIndexRoute
  '/_authenticated/assets/$id/': typeof AuthenticatedAssetsIdIndexRoute
  '/_authenticated/atlas/$department/': typeof AuthenticatedAtlasDepartmentIndexRoute
  '/_authenticated/atlas/documentation/': typeof AuthenticatedAtlasDocumentationIndexRoute
  '/_authenticated/atlas/overview/': typeof AuthenticatedAtlasOverviewIndexRoute
  '/_authenticated/atlas/pulse/': typeof AuthenticatedAtlasPulseIndexRoute
  '/_authenticated/atlas/suggestions/': typeof AuthenticatedAtlasSuggestionsIndexRoute
  '/_authenticated/banking/$id/': typeof AuthenticatedBankingIdIndexRoute
  '/_authenticated/capital-calls/$id/': typeof AuthenticatedCapitalCallsIdIndexRoute
  '/_authenticated/chat/$id/': typeof AuthenticatedChatIdIndexRoute
  '/_authenticated/chat/bugs/': typeof AuthenticatedChatBugsIndexRoute
  '/_authenticated/closes/$id/': typeof AuthenticatedClosesIdIndexRoute
  '/_authenticated/companies/$id/': typeof AuthenticatedCompaniesIdIndexRoute
  '/_authenticated/compliance/$id/': typeof AuthenticatedComplianceIdIndexRoute
  '/_authenticated/compliance/bvi/': typeof AuthenticatedComplianceBviIndexRoute
  '/_authenticated/deals/$id/': typeof AuthenticatedDealsIdIndexRoute
  '/_authenticated/deals/bulk-upload/': typeof AuthenticatedDealsBulkUploadIndexRoute
  '/_authenticated/distributions/$id/': typeof AuthenticatedDistributionsIdIndexRoute
  '/_authenticated/distributions/wires/': typeof AuthenticatedDistributionsWiresIndexRoute
  '/_authenticated/entities/$id/': typeof AuthenticatedEntitiesIdIndexRoute
  '/_authenticated/financials/sheets/': typeof AuthenticatedFinancialsSheetsIndexRoute
  '/_authenticated/fundraising/contacts/': typeof AuthenticatedFundraisingContactsIndexRoute
  '/_authenticated/fundraising/dataroom/': typeof AuthenticatedFundraisingDataroomIndexRoute
  '/_authenticated/fundraising/emails/': typeof AuthenticatedFundraisingEmailsIndexRoute
  '/_authenticated/fundraising/pledges/': typeof AuthenticatedFundraisingPledgesIndexRoute
  '/_authenticated/identities/$id/': typeof AuthenticatedIdentitiesIdIndexRoute
  '/_authenticated/increase-banking/$accountId/': typeof AuthenticatedIncreaseBankingAccountIdIndexRoute
  '/_authenticated/investments/$id/': typeof AuthenticatedInvestmentsIdIndexRoute
  '/_authenticated/logs/api/': typeof AuthenticatedLogsApiIndexRoute
  '/_authenticated/logs/track/': typeof AuthenticatedLogsTrackIndexRoute
  '/_authenticated/membership-transfers/$id/': typeof AuthenticatedMembershipTransfersIdIndexRoute
  '/_authenticated/meow-banking/$entityId/': typeof AuthenticatedMeowBankingEntityIdIndexRoute
  '/_authenticated/organizations/$id/': typeof AuthenticatedOrganizationsIdIndexRoute
  '/_authenticated/pledges/$id/': typeof AuthenticatedPledgesIdIndexRoute
  '/_authenticated/products-pricing/$id/': typeof AuthenticatedProductsPricingIdIndexRoute
  '/_authenticated/sales/pulse/': typeof AuthenticatedSalesPulseIndexRoute
  '/_authenticated/scripts/generate-legal-docs/': typeof AuthenticatedScriptsGenerateLegalDocsIndexRoute
  '/_authenticated/support/search/': typeof AuthenticatedSupportSearchIndexRoute
  '/_authenticated/taxes/discrepancies/': typeof AuthenticatedTaxesDiscrepanciesIndexRoute
  '/_authenticated/taxes/metrics/': typeof AuthenticatedTaxesMetricsIndexRoute
  '/_authenticated/valuations/$id/': typeof AuthenticatedValuationsIdIndexRoute
  '/_authenticated/compliance/bvi/formations/': typeof AuthenticatedComplianceBviFormationsIndexRoute
  '/_authenticated/compliance/bvi/manual/': typeof AuthenticatedComplianceBviManualIndexRoute
  '/_authenticated/distributions/$id/distributions-events/': typeof AuthenticatedDistributionsIdDistributionsEventsIndexRoute
  '/_authenticated/ledger/accounts/$id/': typeof AuthenticatedLedgerAccountsIdIndexRoute
  '/_authenticated/syndicates/$id/admin/': typeof AuthenticatedSyndicatesIdAdminIndexRoute
  '/_authenticated/taxes/$entity_id/$tax_year/': typeof AuthenticatedTaxesEntity_idTax_yearIndexRoute
  '/_authenticated/taxes/discrepancies/$tax_year/': typeof AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute
  '/_authenticated/compliance/bvi/formations/$id/': typeof AuthenticatedComplianceBviFormationsIdIndexRoute
  '/_authenticated/distributions/$id/distributions-events/$eventId/': typeof AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/accounts/spend'
    | '/accounts/spend-by-product'
    | '/ai-studio/$chatId'
    | '/access-management/'
    | '/accounts/'
    | '/activities/'
    | '/administrators/'
    | '/agents/'
    | '/ai-studio/'
    | '/allocations-banking/'
    | '/api-access-manager/'
    | '/app-management/'
    | '/archive-requests/'
    | '/asset-valuations/'
    | '/assets-cleanup/'
    | '/assets/'
    | '/atlas/'
    | '/banking-providers/'
    | '/banking/'
    | '/banners/'
    | '/blue-sky-fees/'
    | '/brokerage-accounts-alpaca/'
    | '/brokerage-accounts/'
    | '/capital-calls/'
    | '/cash-accounts/'
    | '/chat/'
    | '/closes/'
    | '/companies/'
    | '/compliance/'
    | '/crm/'
    | '/deals-with-units/'
    | '/deals/'
    | '/distributions/'
    | '/email-templates/'
    | '/emails/'
    | '/entities/'
    | '/erebor-banking/'
    | '/escalations/'
    | '/external-recipients/'
    | '/faqs/'
    | '/feedbacks/'
    | '/files/'
    | '/financials/'
    | '/fund-manager-network/'
    | '/fund-managers/'
    | '/fundraising/'
    | '/funds/'
    | '/goals/'
    | '/granola/'
    | '/identities/'
    | '/increase-banking/'
    | '/intercom/'
    | '/investments/'
    | '/investor-network/'
    | '/investor-recipients/'
    | '/investor-updates/'
    | '/invoice-items/'
    | '/invoice-requests/'
    | '/invoices/'
    | '/ledger/'
    | '/legal-documents/'
    | '/legal-templates/'
    | '/logs/'
    | '/mail/'
    | '/master/'
    | '/mcp-keys/'
    | '/membership-transfers/'
    | '/meow-banking/'
    | '/migrations/'
    | '/notifications/'
    | '/organizations/'
    | '/pledges/'
    | '/products-pricing/'
    | '/profile/'
    | '/queue-monitor/'
    | '/regulatory-filings/'
    | '/rewards/'
    | '/sales/'
    | '/search/'
    | '/secondaries/'
    | '/security/'
    | '/sell-order-requests/'
    | '/side-letters/'
    | '/signature-logs/'
    | '/skills/'
    | '/spv-fee-discounts/'
    | '/support/'
    | '/syndicates/'
    | '/tasks/'
    | '/tax-penalties/'
    | '/taxes/'
    | '/transactions/'
    | '/unauthorized/'
    | '/users/'
    | '/v0/'
    | '/valuation-entries/'
    | '/valuations/'
    | '/vendors/'
    | '/wire-request-escalations/'
    | '/wire-requests/'
    | '/atlas/$department/$page'
    | '/atlas/suggestions/$id'
    | '/financials/sheets/$sheetId'
    | '/accounts/$id/'
    | '/ai-studio/settings/'
    | '/assets/$id/'
    | '/atlas/$department/'
    | '/atlas/documentation/'
    | '/atlas/overview/'
    | '/atlas/pulse/'
    | '/atlas/suggestions/'
    | '/banking/$id/'
    | '/capital-calls/$id/'
    | '/chat/$id/'
    | '/chat/bugs/'
    | '/closes/$id/'
    | '/companies/$id/'
    | '/compliance/$id/'
    | '/compliance/bvi/'
    | '/deals/$id/'
    | '/deals/bulk-upload/'
    | '/distributions/$id/'
    | '/distributions/wires/'
    | '/entities/$id/'
    | '/financials/sheets/'
    | '/fundraising/contacts/'
    | '/fundraising/dataroom/'
    | '/fundraising/emails/'
    | '/fundraising/pledges/'
    | '/identities/$id/'
    | '/increase-banking/$accountId/'
    | '/investments/$id/'
    | '/logs/api/'
    | '/logs/track/'
    | '/membership-transfers/$id/'
    | '/meow-banking/$entityId/'
    | '/organizations/$id/'
    | '/pledges/$id/'
    | '/products-pricing/$id/'
    | '/sales/pulse/'
    | '/scripts/generate-legal-docs/'
    | '/support/search/'
    | '/taxes/discrepancies/'
    | '/taxes/metrics/'
    | '/valuations/$id/'
    | '/compliance/bvi/formations/'
    | '/compliance/bvi/manual/'
    | '/distributions/$id/distributions-events/'
    | '/ledger/accounts/$id/'
    | '/syndicates/$id/admin/'
    | '/taxes/$entity_id/$tax_year/'
    | '/taxes/discrepancies/$tax_year/'
    | '/compliance/bvi/formations/$id/'
    | '/distributions/$id/distributions-events/$eventId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/accounts/spend'
    | '/accounts/spend-by-product'
    | '/ai-studio/$chatId'
    | '/access-management'
    | '/accounts'
    | '/activities'
    | '/administrators'
    | '/agents'
    | '/ai-studio'
    | '/allocations-banking'
    | '/api-access-manager'
    | '/app-management'
    | '/archive-requests'
    | '/asset-valuations'
    | '/assets-cleanup'
    | '/assets'
    | '/atlas'
    | '/banking-providers'
    | '/banking'
    | '/banners'
    | '/blue-sky-fees'
    | '/brokerage-accounts-alpaca'
    | '/brokerage-accounts'
    | '/capital-calls'
    | '/cash-accounts'
    | '/chat'
    | '/closes'
    | '/companies'
    | '/compliance'
    | '/crm'
    | '/deals-with-units'
    | '/deals'
    | '/distributions'
    | '/email-templates'
    | '/emails'
    | '/entities'
    | '/erebor-banking'
    | '/escalations'
    | '/external-recipients'
    | '/faqs'
    | '/feedbacks'
    | '/files'
    | '/financials'
    | '/fund-manager-network'
    | '/fund-managers'
    | '/fundraising'
    | '/funds'
    | '/goals'
    | '/granola'
    | '/identities'
    | '/increase-banking'
    | '/intercom'
    | '/investments'
    | '/investor-network'
    | '/investor-recipients'
    | '/investor-updates'
    | '/invoice-items'
    | '/invoice-requests'
    | '/invoices'
    | '/ledger'
    | '/legal-documents'
    | '/legal-templates'
    | '/logs'
    | '/mail'
    | '/master'
    | '/mcp-keys'
    | '/membership-transfers'
    | '/meow-banking'
    | '/migrations'
    | '/notifications'
    | '/organizations'
    | '/pledges'
    | '/products-pricing'
    | '/profile'
    | '/queue-monitor'
    | '/regulatory-filings'
    | '/rewards'
    | '/sales'
    | '/search'
    | '/secondaries'
    | '/security'
    | '/sell-order-requests'
    | '/side-letters'
    | '/signature-logs'
    | '/skills'
    | '/spv-fee-discounts'
    | '/support'
    | '/syndicates'
    | '/tasks'
    | '/tax-penalties'
    | '/taxes'
    | '/transactions'
    | '/unauthorized'
    | '/users'
    | '/v0'
    | '/valuation-entries'
    | '/valuations'
    | '/vendors'
    | '/wire-request-escalations'
    | '/wire-requests'
    | '/atlas/$department/$page'
    | '/atlas/suggestions/$id'
    | '/financials/sheets/$sheetId'
    | '/accounts/$id'
    | '/ai-studio/settings'
    | '/assets/$id'
    | '/atlas/$department'
    | '/atlas/documentation'
    | '/atlas/overview'
    | '/atlas/pulse'
    | '/atlas/suggestions'
    | '/banking/$id'
    | '/capital-calls/$id'
    | '/chat/$id'
    | '/chat/bugs'
    | '/closes/$id'
    | '/companies/$id'
    | '/compliance/$id'
    | '/compliance/bvi'
    | '/deals/$id'
    | '/deals/bulk-upload'
    | '/distributions/$id'
    | '/distributions/wires'
    | '/entities/$id'
    | '/financials/sheets'
    | '/fundraising/contacts'
    | '/fundraising/dataroom'
    | '/fundraising/emails'
    | '/fundraising/pledges'
    | '/identities/$id'
    | '/increase-banking/$accountId'
    | '/investments/$id'
    | '/logs/api'
    | '/logs/track'
    | '/membership-transfers/$id'
    | '/meow-banking/$entityId'
    | '/organizations/$id'
    | '/pledges/$id'
    | '/products-pricing/$id'
    | '/sales/pulse'
    | '/scripts/generate-legal-docs'
    | '/support/search'
    | '/taxes/discrepancies'
    | '/taxes/metrics'
    | '/valuations/$id'
    | '/compliance/bvi/formations'
    | '/compliance/bvi/manual'
    | '/distributions/$id/distributions-events'
    | '/ledger/accounts/$id'
    | '/syndicates/$id/admin'
    | '/taxes/$entity_id/$tax_year'
    | '/taxes/discrepancies/$tax_year'
    | '/compliance/bvi/formations/$id'
    | '/distributions/$id/distributions-events/$eventId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/'
    | '/_authenticated/accounts/spend'
    | '/_authenticated/accounts/spend-by-product'
    | '/_authenticated/ai-studio/$chatId'
    | '/_authenticated/access-management/'
    | '/_authenticated/accounts/'
    | '/_authenticated/activities/'
    | '/_authenticated/administrators/'
    | '/_authenticated/agents/'
    | '/_authenticated/ai-studio/'
    | '/_authenticated/allocations-banking/'
    | '/_authenticated/api-access-manager/'
    | '/_authenticated/app-management/'
    | '/_authenticated/archive-requests/'
    | '/_authenticated/asset-valuations/'
    | '/_authenticated/assets-cleanup/'
    | '/_authenticated/assets/'
    | '/_authenticated/atlas/'
    | '/_authenticated/banking-providers/'
    | '/_authenticated/banking/'
    | '/_authenticated/banners/'
    | '/_authenticated/blue-sky-fees/'
    | '/_authenticated/brokerage-accounts-alpaca/'
    | '/_authenticated/brokerage-accounts/'
    | '/_authenticated/capital-calls/'
    | '/_authenticated/cash-accounts/'
    | '/_authenticated/chat/'
    | '/_authenticated/closes/'
    | '/_authenticated/companies/'
    | '/_authenticated/compliance/'
    | '/_authenticated/crm/'
    | '/_authenticated/deals-with-units/'
    | '/_authenticated/deals/'
    | '/_authenticated/distributions/'
    | '/_authenticated/email-templates/'
    | '/_authenticated/emails/'
    | '/_authenticated/entities/'
    | '/_authenticated/erebor-banking/'
    | '/_authenticated/escalations/'
    | '/_authenticated/external-recipients/'
    | '/_authenticated/faqs/'
    | '/_authenticated/feedbacks/'
    | '/_authenticated/files/'
    | '/_authenticated/financials/'
    | '/_authenticated/fund-manager-network/'
    | '/_authenticated/fund-managers/'
    | '/_authenticated/fundraising/'
    | '/_authenticated/funds/'
    | '/_authenticated/goals/'
    | '/_authenticated/granola/'
    | '/_authenticated/identities/'
    | '/_authenticated/increase-banking/'
    | '/_authenticated/intercom/'
    | '/_authenticated/investments/'
    | '/_authenticated/investor-network/'
    | '/_authenticated/investor-recipients/'
    | '/_authenticated/investor-updates/'
    | '/_authenticated/invoice-items/'
    | '/_authenticated/invoice-requests/'
    | '/_authenticated/invoices/'
    | '/_authenticated/ledger/'
    | '/_authenticated/legal-documents/'
    | '/_authenticated/legal-templates/'
    | '/_authenticated/logs/'
    | '/_authenticated/mail/'
    | '/_authenticated/master/'
    | '/_authenticated/mcp-keys/'
    | '/_authenticated/membership-transfers/'
    | '/_authenticated/meow-banking/'
    | '/_authenticated/migrations/'
    | '/_authenticated/notifications/'
    | '/_authenticated/organizations/'
    | '/_authenticated/pledges/'
    | '/_authenticated/products-pricing/'
    | '/_authenticated/profile/'
    | '/_authenticated/queue-monitor/'
    | '/_authenticated/regulatory-filings/'
    | '/_authenticated/rewards/'
    | '/_authenticated/sales/'
    | '/_authenticated/search/'
    | '/_authenticated/secondaries/'
    | '/_authenticated/security/'
    | '/_authenticated/sell-order-requests/'
    | '/_authenticated/side-letters/'
    | '/_authenticated/signature-logs/'
    | '/_authenticated/skills/'
    | '/_authenticated/spv-fee-discounts/'
    | '/_authenticated/support/'
    | '/_authenticated/syndicates/'
    | '/_authenticated/tasks/'
    | '/_authenticated/tax-penalties/'
    | '/_authenticated/taxes/'
    | '/_authenticated/transactions/'
    | '/_authenticated/unauthorized/'
    | '/_authenticated/users/'
    | '/_authenticated/v0/'
    | '/_authenticated/valuation-entries/'
    | '/_authenticated/valuations/'
    | '/_authenticated/vendors/'
    | '/_authenticated/wire-request-escalations/'
    | '/_authenticated/wire-requests/'
    | '/_authenticated/atlas/$department/$page'
    | '/_authenticated/atlas/suggestions/$id'
    | '/_authenticated/financials/sheets/$sheetId'
    | '/_authenticated/accounts/$id/'
    | '/_authenticated/ai-studio/settings/'
    | '/_authenticated/assets/$id/'
    | '/_authenticated/atlas/$department/'
    | '/_authenticated/atlas/documentation/'
    | '/_authenticated/atlas/overview/'
    | '/_authenticated/atlas/pulse/'
    | '/_authenticated/atlas/suggestions/'
    | '/_authenticated/banking/$id/'
    | '/_authenticated/capital-calls/$id/'
    | '/_authenticated/chat/$id/'
    | '/_authenticated/chat/bugs/'
    | '/_authenticated/closes/$id/'
    | '/_authenticated/companies/$id/'
    | '/_authenticated/compliance/$id/'
    | '/_authenticated/compliance/bvi/'
    | '/_authenticated/deals/$id/'
    | '/_authenticated/deals/bulk-upload/'
    | '/_authenticated/distributions/$id/'
    | '/_authenticated/distributions/wires/'
    | '/_authenticated/entities/$id/'
    | '/_authenticated/financials/sheets/'
    | '/_authenticated/fundraising/contacts/'
    | '/_authenticated/fundraising/dataroom/'
    | '/_authenticated/fundraising/emails/'
    | '/_authenticated/fundraising/pledges/'
    | '/_authenticated/identities/$id/'
    | '/_authenticated/increase-banking/$accountId/'
    | '/_authenticated/investments/$id/'
    | '/_authenticated/logs/api/'
    | '/_authenticated/logs/track/'
    | '/_authenticated/membership-transfers/$id/'
    | '/_authenticated/meow-banking/$entityId/'
    | '/_authenticated/organizations/$id/'
    | '/_authenticated/pledges/$id/'
    | '/_authenticated/products-pricing/$id/'
    | '/_authenticated/sales/pulse/'
    | '/_authenticated/scripts/generate-legal-docs/'
    | '/_authenticated/support/search/'
    | '/_authenticated/taxes/discrepancies/'
    | '/_authenticated/taxes/metrics/'
    | '/_authenticated/valuations/$id/'
    | '/_authenticated/compliance/bvi/formations/'
    | '/_authenticated/compliance/bvi/manual/'
    | '/_authenticated/distributions/$id/distributions-events/'
    | '/_authenticated/ledger/accounts/$id/'
    | '/_authenticated/syndicates/$id/admin/'
    | '/_authenticated/taxes/$entity_id/$tax_year/'
    | '/_authenticated/taxes/discrepancies/$tax_year/'
    | '/_authenticated/compliance/bvi/formations/$id/'
    | '/_authenticated/distributions/$id/distributions-events/$eventId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wire-requests/': {
      id: '/_authenticated/wire-requests/'
      path: '/wire-requests'
      fullPath: '/wire-requests/'
      preLoaderRoute: typeof AuthenticatedWireRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wire-request-escalations/': {
      id: '/_authenticated/wire-request-escalations/'
      path: '/wire-request-escalations'
      fullPath: '/wire-request-escalations/'
      preLoaderRoute: typeof AuthenticatedWireRequestEscalationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vendors/': {
      id: '/_authenticated/vendors/'
      path: '/vendors'
      fullPath: '/vendors/'
      preLoaderRoute: typeof AuthenticatedVendorsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/valuations/': {
      id: '/_authenticated/valuations/'
      path: '/valuations'
      fullPath: '/valuations/'
      preLoaderRoute: typeof AuthenticatedValuationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/valuation-entries/': {
      id: '/_authenticated/valuation-entries/'
      path: '/valuation-entries'
      fullPath: '/valuation-entries/'
      preLoaderRoute: typeof AuthenticatedValuationEntriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/v0/': {
      id: '/_authenticated/v0/'
      path: '/v0'
      fullPath: '/v0/'
      preLoaderRoute: typeof AuthenticatedV0IndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/unauthorized/': {
      id: '/_authenticated/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized/'
      preLoaderRoute: typeof AuthenticatedUnauthorizedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transactions/': {
      id: '/_authenticated/transactions/'
      path: '/transactions'
      fullPath: '/transactions/'
      preLoaderRoute: typeof AuthenticatedTransactionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/taxes/': {
      id: '/_authenticated/taxes/'
      path: '/taxes'
      fullPath: '/taxes/'
      preLoaderRoute: typeof AuthenticatedTaxesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tax-penalties/': {
      id: '/_authenticated/tax-penalties/'
      path: '/tax-penalties'
      fullPath: '/tax-penalties/'
      preLoaderRoute: typeof AuthenticatedTaxPenaltiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/syndicates/': {
      id: '/_authenticated/syndicates/'
      path: '/syndicates'
      fullPath: '/syndicates/'
      preLoaderRoute: typeof AuthenticatedSyndicatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthenticatedSupportIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spv-fee-discounts/': {
      id: '/_authenticated/spv-fee-discounts/'
      path: '/spv-fee-discounts'
      fullPath: '/spv-fee-discounts/'
      preLoaderRoute: typeof AuthenticatedSpvFeeDiscountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills/': {
      id: '/_authenticated/skills/'
      path: '/skills'
      fullPath: '/skills/'
      preLoaderRoute: typeof AuthenticatedSkillsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/signature-logs/': {
      id: '/_authenticated/signature-logs/'
      path: '/signature-logs'
      fullPath: '/signature-logs/'
      preLoaderRoute: typeof AuthenticatedSignatureLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/side-letters/': {
      id: '/_authenticated/side-letters/'
      path: '/side-letters'
      fullPath: '/side-letters/'
      preLoaderRoute: typeof AuthenticatedSideLettersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sell-order-requests/': {
      id: '/_authenticated/sell-order-requests/'
      path: '/sell-order-requests'
      fullPath: '/sell-order-requests/'
      preLoaderRoute: typeof AuthenticatedSellOrderRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/security/': {
      id: '/_authenticated/security/'
      path: '/security'
      fullPath: '/security/'
      preLoaderRoute: typeof AuthenticatedSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/secondaries/': {
      id: '/_authenticated/secondaries/'
      path: '/secondaries'
      fullPath: '/secondaries/'
      preLoaderRoute: typeof AuthenticatedSecondariesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search/': {
      id: '/_authenticated/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AuthenticatedSearchIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/': {
      id: '/_authenticated/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AuthenticatedSalesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rewards/': {
      id: '/_authenticated/rewards/'
      path: '/rewards'
      fullPath: '/rewards/'
      preLoaderRoute: typeof AuthenticatedRewardsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/regulatory-filings/': {
      id: '/_authenticated/regulatory-filings/'
      path: '/regulatory-filings'
      fullPath: '/regulatory-filings/'
      preLoaderRoute: typeof AuthenticatedRegulatoryFilingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/queue-monitor/': {
      id: '/_authenticated/queue-monitor/'
      path: '/queue-monitor'
      fullPath: '/queue-monitor/'
      preLoaderRoute: typeof AuthenticatedQueueMonitorIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products-pricing/': {
      id: '/_authenticated/products-pricing/'
      path: '/products-pricing'
      fullPath: '/products-pricing/'
      preLoaderRoute: typeof AuthenticatedProductsPricingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pledges/': {
      id: '/_authenticated/pledges/'
      path: '/pledges'
      fullPath: '/pledges/'
      preLoaderRoute: typeof AuthenticatedPledgesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/migrations/': {
      id: '/_authenticated/migrations/'
      path: '/migrations'
      fullPath: '/migrations/'
      preLoaderRoute: typeof AuthenticatedMigrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meow-banking/': {
      id: '/_authenticated/meow-banking/'
      path: '/meow-banking'
      fullPath: '/meow-banking/'
      preLoaderRoute: typeof AuthenticatedMeowBankingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/membership-transfers/': {
      id: '/_authenticated/membership-transfers/'
      path: '/membership-transfers'
      fullPath: '/membership-transfers/'
      preLoaderRoute: typeof AuthenticatedMembershipTransfersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mcp-keys/': {
      id: '/_authenticated/mcp-keys/'
      path: '/mcp-keys'
      fullPath: '/mcp-keys/'
      preLoaderRoute: typeof AuthenticatedMcpKeysIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/master/': {
      id: '/_authenticated/master/'
      path: '/master'
      fullPath: '/master/'
      preLoaderRoute: typeof AuthenticatedMasterIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mail/': {
      id: '/_authenticated/mail/'
      path: '/mail'
      fullPath: '/mail/'
      preLoaderRoute: typeof AuthenticatedMailIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logs/': {
      id: '/_authenticated/logs/'
      path: '/logs'
      fullPath: '/logs/'
      preLoaderRoute: typeof AuthenticatedLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/legal-templates/': {
      id: '/_authenticated/legal-templates/'
      path: '/legal-templates'
      fullPath: '/legal-templates/'
      preLoaderRoute: typeof AuthenticatedLegalTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/legal-documents/': {
      id: '/_authenticated/legal-documents/'
      path: '/legal-documents'
      fullPath: '/legal-documents/'
      preLoaderRoute: typeof AuthenticatedLegalDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ledger/': {
      id: '/_authenticated/ledger/'
      path: '/ledger'
      fullPath: '/ledger/'
      preLoaderRoute: typeof AuthenticatedLedgerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoice-requests/': {
      id: '/_authenticated/invoice-requests/'
      path: '/invoice-requests'
      fullPath: '/invoice-requests/'
      preLoaderRoute: typeof AuthenticatedInvoiceRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoice-items/': {
      id: '/_authenticated/invoice-items/'
      path: '/invoice-items'
      fullPath: '/invoice-items/'
      preLoaderRoute: typeof AuthenticatedInvoiceItemsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investor-updates/': {
      id: '/_authenticated/investor-updates/'
      path: '/investor-updates'
      fullPath: '/investor-updates/'
      preLoaderRoute: typeof AuthenticatedInvestorUpdatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investor-recipients/': {
      id: '/_authenticated/investor-recipients/'
      path: '/investor-recipients'
      fullPath: '/investor-recipients/'
      preLoaderRoute: typeof AuthenticatedInvestorRecipientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investor-network/': {
      id: '/_authenticated/investor-network/'
      path: '/investor-network'
      fullPath: '/investor-network/'
      preLoaderRoute: typeof AuthenticatedInvestorNetworkIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investments/': {
      id: '/_authenticated/investments/'
      path: '/investments'
      fullPath: '/investments/'
      preLoaderRoute: typeof AuthenticatedInvestmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/intercom/': {
      id: '/_authenticated/intercom/'
      path: '/intercom'
      fullPath: '/intercom/'
      preLoaderRoute: typeof AuthenticatedIntercomIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/increase-banking/': {
      id: '/_authenticated/increase-banking/'
      path: '/increase-banking'
      fullPath: '/increase-banking/'
      preLoaderRoute: typeof AuthenticatedIncreaseBankingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/identities/': {
      id: '/_authenticated/identities/'
      path: '/identities'
      fullPath: '/identities/'
      preLoaderRoute: typeof AuthenticatedIdentitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/granola/': {
      id: '/_authenticated/granola/'
      path: '/granola'
      fullPath: '/granola/'
      preLoaderRoute: typeof AuthenticatedGranolaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/funds/': {
      id: '/_authenticated/funds/'
      path: '/funds'
      fullPath: '/funds/'
      preLoaderRoute: typeof AuthenticatedFundsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fundraising/': {
      id: '/_authenticated/fundraising/'
      path: '/fundraising'
      fullPath: '/fundraising/'
      preLoaderRoute: typeof AuthenticatedFundraisingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fund-managers/': {
      id: '/_authenticated/fund-managers/'
      path: '/fund-managers'
      fullPath: '/fund-managers/'
      preLoaderRoute: typeof AuthenticatedFundManagersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fund-manager-network/': {
      id: '/_authenticated/fund-manager-network/'
      path: '/fund-manager-network'
      fullPath: '/fund-manager-network/'
      preLoaderRoute: typeof AuthenticatedFundManagerNetworkIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/financials/': {
      id: '/_authenticated/financials/'
      path: '/financials'
      fullPath: '/financials/'
      preLoaderRoute: typeof AuthenticatedFinancialsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/': {
      id: '/_authenticated/files/'
      path: '/files'
      fullPath: '/files/'
      preLoaderRoute: typeof AuthenticatedFilesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feedbacks/': {
      id: '/_authenticated/feedbacks/'
      path: '/feedbacks'
      fullPath: '/feedbacks/'
      preLoaderRoute: typeof AuthenticatedFeedbacksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/faqs/': {
      id: '/_authenticated/faqs/'
      path: '/faqs'
      fullPath: '/faqs/'
      preLoaderRoute: typeof AuthenticatedFaqsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/external-recipients/': {
      id: '/_authenticated/external-recipients/'
      path: '/external-recipients'
      fullPath: '/external-recipients/'
      preLoaderRoute: typeof AuthenticatedExternalRecipientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/escalations/': {
      id: '/_authenticated/escalations/'
      path: '/escalations'
      fullPath: '/escalations/'
      preLoaderRoute: typeof AuthenticatedEscalationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/erebor-banking/': {
      id: '/_authenticated/erebor-banking/'
      path: '/erebor-banking'
      fullPath: '/erebor-banking/'
      preLoaderRoute: typeof AuthenticatedEreborBankingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/': {
      id: '/_authenticated/entities/'
      path: '/entities'
      fullPath: '/entities/'
      preLoaderRoute: typeof AuthenticatedEntitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/emails/': {
      id: '/_authenticated/emails/'
      path: '/emails'
      fullPath: '/emails/'
      preLoaderRoute: typeof AuthenticatedEmailsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-templates/': {
      id: '/_authenticated/email-templates/'
      path: '/email-templates'
      fullPath: '/email-templates/'
      preLoaderRoute: typeof AuthenticatedEmailTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/distributions/': {
      id: '/_authenticated/distributions/'
      path: '/distributions'
      fullPath: '/distributions/'
      preLoaderRoute: typeof AuthenticatedDistributionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/deals/': {
      id: '/_authenticated/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AuthenticatedDealsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/deals-with-units/': {
      id: '/_authenticated/deals-with-units/'
      path: '/deals-with-units'
      fullPath: '/deals-with-units/'
      preLoaderRoute: typeof AuthenticatedDealsWithUnitsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/crm/': {
      id: '/_authenticated/crm/'
      path: '/crm'
      fullPath: '/crm/'
      preLoaderRoute: typeof AuthenticatedCrmIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/': {
      id: '/_authenticated/compliance/'
      path: '/compliance'
      fullPath: '/compliance/'
      preLoaderRoute: typeof AuthenticatedComplianceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/closes/': {
      id: '/_authenticated/closes/'
      path: '/closes'
      fullPath: '/closes/'
      preLoaderRoute: typeof AuthenticatedClosesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/': {
      id: '/_authenticated/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cash-accounts/': {
      id: '/_authenticated/cash-accounts/'
      path: '/cash-accounts'
      fullPath: '/cash-accounts/'
      preLoaderRoute: typeof AuthenticatedCashAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/capital-calls/': {
      id: '/_authenticated/capital-calls/'
      path: '/capital-calls'
      fullPath: '/capital-calls/'
      preLoaderRoute: typeof AuthenticatedCapitalCallsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brokerage-accounts/': {
      id: '/_authenticated/brokerage-accounts/'
      path: '/brokerage-accounts'
      fullPath: '/brokerage-accounts/'
      preLoaderRoute: typeof AuthenticatedBrokerageAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brokerage-accounts-alpaca/': {
      id: '/_authenticated/brokerage-accounts-alpaca/'
      path: '/brokerage-accounts-alpaca'
      fullPath: '/brokerage-accounts-alpaca/'
      preLoaderRoute: typeof AuthenticatedBrokerageAccountsAlpacaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blue-sky-fees/': {
      id: '/_authenticated/blue-sky-fees/'
      path: '/blue-sky-fees'
      fullPath: '/blue-sky-fees/'
      preLoaderRoute: typeof AuthenticatedBlueSkyFeesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banners/': {
      id: '/_authenticated/banners/'
      path: '/banners'
      fullPath: '/banners/'
      preLoaderRoute: typeof AuthenticatedBannersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banking/': {
      id: '/_authenticated/banking/'
      path: '/banking'
      fullPath: '/banking/'
      preLoaderRoute: typeof AuthenticatedBankingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banking-providers/': {
      id: '/_authenticated/banking-providers/'
      path: '/banking-providers'
      fullPath: '/banking-providers/'
      preLoaderRoute: typeof AuthenticatedBankingProvidersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/': {
      id: '/_authenticated/atlas/'
      path: '/atlas'
      fullPath: '/atlas/'
      preLoaderRoute: typeof AuthenticatedAtlasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/': {
      id: '/_authenticated/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets-cleanup/': {
      id: '/_authenticated/assets-cleanup/'
      path: '/assets-cleanup'
      fullPath: '/assets-cleanup/'
      preLoaderRoute: typeof AuthenticatedAssetsCleanupIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/asset-valuations/': {
      id: '/_authenticated/asset-valuations/'
      path: '/asset-valuations'
      fullPath: '/asset-valuations/'
      preLoaderRoute: typeof AuthenticatedAssetValuationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/archive-requests/': {
      id: '/_authenticated/archive-requests/'
      path: '/archive-requests'
      fullPath: '/archive-requests/'
      preLoaderRoute: typeof AuthenticatedArchiveRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-management/': {
      id: '/_authenticated/app-management/'
      path: '/app-management'
      fullPath: '/app-management/'
      preLoaderRoute: typeof AuthenticatedAppManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/api-access-manager/': {
      id: '/_authenticated/api-access-manager/'
      path: '/api-access-manager'
      fullPath: '/api-access-manager/'
      preLoaderRoute: typeof AuthenticatedApiAccessManagerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/allocations-banking/': {
      id: '/_authenticated/allocations-banking/'
      path: '/allocations-banking'
      fullPath: '/allocations-banking/'
      preLoaderRoute: typeof AuthenticatedAllocationsBankingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-studio/': {
      id: '/_authenticated/ai-studio/'
      path: '/ai-studio'
      fullPath: '/ai-studio/'
      preLoaderRoute: typeof AuthenticatedAiStudioIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agents/': {
      id: '/_authenticated/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthenticatedAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/administrators/': {
      id: '/_authenticated/administrators/'
      path: '/administrators'
      fullPath: '/administrators/'
      preLoaderRoute: typeof AuthenticatedAdministratorsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activities/': {
      id: '/_authenticated/activities/'
      path: '/activities'
      fullPath: '/activities/'
      preLoaderRoute: typeof AuthenticatedActivitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/': {
      id: '/_authenticated/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthenticatedAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access-management/': {
      id: '/_authenticated/access-management/'
      path: '/access-management'
      fullPath: '/access-management/'
      preLoaderRoute: typeof AuthenticatedAccessManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-studio/$chatId': {
      id: '/_authenticated/ai-studio/$chatId'
      path: '/ai-studio/$chatId'
      fullPath: '/ai-studio/$chatId'
      preLoaderRoute: typeof AuthenticatedAiStudioChatIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/spend-by-product': {
      id: '/_authenticated/accounts/spend-by-product'
      path: '/accounts/spend-by-product'
      fullPath: '/accounts/spend-by-product'
      preLoaderRoute: typeof AuthenticatedAccountsSpendByProductRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/spend': {
      id: '/_authenticated/accounts/spend'
      path: '/accounts/spend'
      fullPath: '/accounts/spend'
      preLoaderRoute: typeof AuthenticatedAccountsSpendRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/valuations/$id/': {
      id: '/_authenticated/valuations/$id/'
      path: '/valuations/$id'
      fullPath: '/valuations/$id/'
      preLoaderRoute: typeof AuthenticatedValuationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/taxes/metrics/': {
      id: '/_authenticated/taxes/metrics/'
      path: '/taxes/metrics'
      fullPath: '/taxes/metrics/'
      preLoaderRoute: typeof AuthenticatedTaxesMetricsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/taxes/discrepancies/': {
      id: '/_authenticated/taxes/discrepancies/'
      path: '/taxes/discrepancies'
      fullPath: '/taxes/discrepancies/'
      preLoaderRoute: typeof AuthenticatedTaxesDiscrepanciesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support/search/': {
      id: '/_authenticated/support/search/'
      path: '/support/search'
      fullPath: '/support/search/'
      preLoaderRoute: typeof AuthenticatedSupportSearchIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/scripts/generate-legal-docs/': {
      id: '/_authenticated/scripts/generate-legal-docs/'
      path: '/scripts/generate-legal-docs'
      fullPath: '/scripts/generate-legal-docs/'
      preLoaderRoute: typeof AuthenticatedScriptsGenerateLegalDocsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/pulse/': {
      id: '/_authenticated/sales/pulse/'
      path: '/sales/pulse'
      fullPath: '/sales/pulse/'
      preLoaderRoute: typeof AuthenticatedSalesPulseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products-pricing/$id/': {
      id: '/_authenticated/products-pricing/$id/'
      path: '/products-pricing/$id'
      fullPath: '/products-pricing/$id/'
      preLoaderRoute: typeof AuthenticatedProductsPricingIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pledges/$id/': {
      id: '/_authenticated/pledges/$id/'
      path: '/pledges/$id'
      fullPath: '/pledges/$id/'
      preLoaderRoute: typeof AuthenticatedPledgesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/$id/': {
      id: '/_authenticated/organizations/$id/'
      path: '/organizations/$id'
      fullPath: '/organizations/$id/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meow-banking/$entityId/': {
      id: '/_authenticated/meow-banking/$entityId/'
      path: '/meow-banking/$entityId'
      fullPath: '/meow-banking/$entityId/'
      preLoaderRoute: typeof AuthenticatedMeowBankingEntityIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/membership-transfers/$id/': {
      id: '/_authenticated/membership-transfers/$id/'
      path: '/membership-transfers/$id'
      fullPath: '/membership-transfers/$id/'
      preLoaderRoute: typeof AuthenticatedMembershipTransfersIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logs/track/': {
      id: '/_authenticated/logs/track/'
      path: '/logs/track'
      fullPath: '/logs/track/'
      preLoaderRoute: typeof AuthenticatedLogsTrackIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logs/api/': {
      id: '/_authenticated/logs/api/'
      path: '/logs/api'
      fullPath: '/logs/api/'
      preLoaderRoute: typeof AuthenticatedLogsApiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/investments/$id/': {
      id: '/_authenticated/investments/$id/'
      path: '/investments/$id'
      fullPath: '/investments/$id/'
      preLoaderRoute: typeof AuthenticatedInvestmentsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/increase-banking/$accountId/': {
      id: '/_authenticated/increase-banking/$accountId/'
      path: '/increase-banking/$accountId'
      fullPath: '/increase-banking/$accountId/'
      preLoaderRoute: typeof AuthenticatedIncreaseBankingAccountIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/identities/$id/': {
      id: '/_authenticated/identities/$id/'
      path: '/identities/$id'
      fullPath: '/identities/$id/'
      preLoaderRoute: typeof AuthenticatedIdentitiesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fundraising/pledges/': {
      id: '/_authenticated/fundraising/pledges/'
      path: '/fundraising/pledges'
      fullPath: '/fundraising/pledges/'
      preLoaderRoute: typeof AuthenticatedFundraisingPledgesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fundraising/emails/': {
      id: '/_authenticated/fundraising/emails/'
      path: '/fundraising/emails'
      fullPath: '/fundraising/emails/'
      preLoaderRoute: typeof AuthenticatedFundraisingEmailsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fundraising/dataroom/': {
      id: '/_authenticated/fundraising/dataroom/'
      path: '/fundraising/dataroom'
      fullPath: '/fundraising/dataroom/'
      preLoaderRoute: typeof AuthenticatedFundraisingDataroomIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fundraising/contacts/': {
      id: '/_authenticated/fundraising/contacts/'
      path: '/fundraising/contacts'
      fullPath: '/fundraising/contacts/'
      preLoaderRoute: typeof AuthenticatedFundraisingContactsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/financials/sheets/': {
      id: '/_authenticated/financials/sheets/'
      path: '/financials/sheets'
      fullPath: '/financials/sheets/'
      preLoaderRoute: typeof AuthenticatedFinancialsSheetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/$id/': {
      id: '/_authenticated/entities/$id/'
      path: '/entities/$id'
      fullPath: '/entities/$id/'
      preLoaderRoute: typeof AuthenticatedEntitiesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/distributions/wires/': {
      id: '/_authenticated/distributions/wires/'
      path: '/distributions/wires'
      fullPath: '/distributions/wires/'
      preLoaderRoute: typeof AuthenticatedDistributionsWiresIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/distributions/$id/': {
      id: '/_authenticated/distributions/$id/'
      path: '/distributions/$id'
      fullPath: '/distributions/$id/'
      preLoaderRoute: typeof AuthenticatedDistributionsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/deals/bulk-upload/': {
      id: '/_authenticated/deals/bulk-upload/'
      path: '/deals/bulk-upload'
      fullPath: '/deals/bulk-upload/'
      preLoaderRoute: typeof AuthenticatedDealsBulkUploadIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/deals/$id/': {
      id: '/_authenticated/deals/$id/'
      path: '/deals/$id'
      fullPath: '/deals/$id/'
      preLoaderRoute: typeof AuthenticatedDealsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/bvi/': {
      id: '/_authenticated/compliance/bvi/'
      path: '/compliance/bvi'
      fullPath: '/compliance/bvi/'
      preLoaderRoute: typeof AuthenticatedComplianceBviIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/$id/': {
      id: '/_authenticated/compliance/$id/'
      path: '/compliance/$id'
      fullPath: '/compliance/$id/'
      preLoaderRoute: typeof AuthenticatedComplianceIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$id/': {
      id: '/_authenticated/companies/$id/'
      path: '/companies/$id'
      fullPath: '/companies/$id/'
      preLoaderRoute: typeof AuthenticatedCompaniesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/closes/$id/': {
      id: '/_authenticated/closes/$id/'
      path: '/closes/$id'
      fullPath: '/closes/$id/'
      preLoaderRoute: typeof AuthenticatedClosesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/bugs/': {
      id: '/_authenticated/chat/bugs/'
      path: '/chat/bugs'
      fullPath: '/chat/bugs/'
      preLoaderRoute: typeof AuthenticatedChatBugsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/$id/': {
      id: '/_authenticated/chat/$id/'
      path: '/chat/$id'
      fullPath: '/chat/$id/'
      preLoaderRoute: typeof AuthenticatedChatIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/capital-calls/$id/': {
      id: '/_authenticated/capital-calls/$id/'
      path: '/capital-calls/$id'
      fullPath: '/capital-calls/$id/'
      preLoaderRoute: typeof AuthenticatedCapitalCallsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banking/$id/': {
      id: '/_authenticated/banking/$id/'
      path: '/banking/$id'
      fullPath: '/banking/$id/'
      preLoaderRoute: typeof AuthenticatedBankingIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/suggestions/': {
      id: '/_authenticated/atlas/suggestions/'
      path: '/atlas/suggestions'
      fullPath: '/atlas/suggestions/'
      preLoaderRoute: typeof AuthenticatedAtlasSuggestionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/pulse/': {
      id: '/_authenticated/atlas/pulse/'
      path: '/atlas/pulse'
      fullPath: '/atlas/pulse/'
      preLoaderRoute: typeof AuthenticatedAtlasPulseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/overview/': {
      id: '/_authenticated/atlas/overview/'
      path: '/atlas/overview'
      fullPath: '/atlas/overview/'
      preLoaderRoute: typeof AuthenticatedAtlasOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/documentation/': {
      id: '/_authenticated/atlas/documentation/'
      path: '/atlas/documentation'
      fullPath: '/atlas/documentation/'
      preLoaderRoute: typeof AuthenticatedAtlasDocumentationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/$department/': {
      id: '/_authenticated/atlas/$department/'
      path: '/atlas/$department'
      fullPath: '/atlas/$department/'
      preLoaderRoute: typeof AuthenticatedAtlasDepartmentIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/$id/': {
      id: '/_authenticated/assets/$id/'
      path: '/assets/$id'
      fullPath: '/assets/$id/'
      preLoaderRoute: typeof AuthenticatedAssetsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-studio/settings/': {
      id: '/_authenticated/ai-studio/settings/'
      path: '/ai-studio/settings'
      fullPath: '/ai-studio/settings/'
      preLoaderRoute: typeof AuthenticatedAiStudioSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts/$id/': {
      id: '/_authenticated/accounts/$id/'
      path: '/accounts/$id'
      fullPath: '/accounts/$id/'
      preLoaderRoute: typeof AuthenticatedAccountsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/financials/sheets/$sheetId': {
      id: '/_authenticated/financials/sheets/$sheetId'
      path: '/financials/sheets/$sheetId'
      fullPath: '/financials/sheets/$sheetId'
      preLoaderRoute: typeof AuthenticatedFinancialsSheetsSheetIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/suggestions/$id': {
      id: '/_authenticated/atlas/suggestions/$id'
      path: '/atlas/suggestions/$id'
      fullPath: '/atlas/suggestions/$id'
      preLoaderRoute: typeof AuthenticatedAtlasSuggestionsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/atlas/$department/$page': {
      id: '/_authenticated/atlas/$department/$page'
      path: '/atlas/$department/$page'
      fullPath: '/atlas/$department/$page'
      preLoaderRoute: typeof AuthenticatedAtlasDepartmentPageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/taxes/discrepancies/$tax_year/': {
      id: '/_authenticated/taxes/discrepancies/$tax_year/'
      path: '/taxes/discrepancies/$tax_year'
      fullPath: '/taxes/discrepancies/$tax_year/'
      preLoaderRoute: typeof AuthenticatedTaxesDiscrepanciesTax_yearIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/taxes/$entity_id/$tax_year/': {
      id: '/_authenticated/taxes/$entity_id/$tax_year/'
      path: '/taxes/$entity_id/$tax_year'
      fullPath: '/taxes/$entity_id/$tax_year/'
      preLoaderRoute: typeof AuthenticatedTaxesEntity_idTax_yearIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/syndicates/$id/admin/': {
      id: '/_authenticated/syndicates/$id/admin/'
      path: '/syndicates/$id/admin'
      fullPath: '/syndicates/$id/admin/'
      preLoaderRoute: typeof AuthenticatedSyndicatesIdAdminIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ledger/accounts/$id/': {
      id: '/_authenticated/ledger/accounts/$id/'
      path: '/ledger/accounts/$id'
      fullPath: '/ledger/accounts/$id/'
      preLoaderRoute: typeof AuthenticatedLedgerAccountsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/distributions/$id/distributions-events/': {
      id: '/_authenticated/distributions/$id/distributions-events/'
      path: '/distributions/$id/distributions-events'
      fullPath: '/distributions/$id/distributions-events/'
      preLoaderRoute: typeof AuthenticatedDistributionsIdDistributionsEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/bvi/manual/': {
      id: '/_authenticated/compliance/bvi/manual/'
      path: '/compliance/bvi/manual'
      fullPath: '/compliance/bvi/manual/'
      preLoaderRoute: typeof AuthenticatedComplianceBviManualIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/bvi/formations/': {
      id: '/_authenticated/compliance/bvi/formations/'
      path: '/compliance/bvi/formations'
      fullPath: '/compliance/bvi/formations/'
      preLoaderRoute: typeof AuthenticatedComplianceBviFormationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/distributions/$id/distributions-events/$eventId/': {
      id: '/_authenticated/distributions/$id/distributions-events/$eventId/'
      path: '/distributions/$id/distributions-events/$eventId'
      fullPath: '/distributions/$id/distributions-events/$eventId/'
      preLoaderRoute: typeof AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/bvi/formations/$id/': {
      id: '/_authenticated/compliance/bvi/formations/$id/'
      path: '/compliance/bvi/formations/$id'
      fullPath: '/compliance/bvi/formations/$id/'
      preLoaderRoute: typeof AuthenticatedComplianceBviFormationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccountsSpendRoute: typeof AuthenticatedAccountsSpendRoute
  AuthenticatedAccountsSpendByProductRoute: typeof AuthenticatedAccountsSpendByProductRoute
  AuthenticatedAiStudioChatIdRoute: typeof AuthenticatedAiStudioChatIdRoute
  AuthenticatedAccessManagementIndexRoute: typeof AuthenticatedAccessManagementIndexRoute
  AuthenticatedAccountsIndexRoute: typeof AuthenticatedAccountsIndexRoute
  AuthenticatedActivitiesIndexRoute: typeof AuthenticatedActivitiesIndexRoute
  AuthenticatedAdministratorsIndexRoute: typeof AuthenticatedAdministratorsIndexRoute
  AuthenticatedAgentsIndexRoute: typeof AuthenticatedAgentsIndexRoute
  AuthenticatedAiStudioIndexRoute: typeof AuthenticatedAiStudioIndexRoute
  AuthenticatedAllocationsBankingIndexRoute: typeof AuthenticatedAllocationsBankingIndexRoute
  AuthenticatedApiAccessManagerIndexRoute: typeof AuthenticatedApiAccessManagerIndexRoute
  AuthenticatedAppManagementIndexRoute: typeof AuthenticatedAppManagementIndexRoute
  AuthenticatedArchiveRequestsIndexRoute: typeof AuthenticatedArchiveRequestsIndexRoute
  AuthenticatedAssetValuationsIndexRoute: typeof AuthenticatedAssetValuationsIndexRoute
  AuthenticatedAssetsCleanupIndexRoute: typeof AuthenticatedAssetsCleanupIndexRoute
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute
  AuthenticatedAtlasIndexRoute: typeof AuthenticatedAtlasIndexRoute
  AuthenticatedBankingProvidersIndexRoute: typeof AuthenticatedBankingProvidersIndexRoute
  AuthenticatedBankingIndexRoute: typeof AuthenticatedBankingIndexRoute
  AuthenticatedBannersIndexRoute: typeof AuthenticatedBannersIndexRoute
  AuthenticatedBlueSkyFeesIndexRoute: typeof AuthenticatedBlueSkyFeesIndexRoute
  AuthenticatedBrokerageAccountsAlpacaIndexRoute: typeof AuthenticatedBrokerageAccountsAlpacaIndexRoute
  AuthenticatedBrokerageAccountsIndexRoute: typeof AuthenticatedBrokerageAccountsIndexRoute
  AuthenticatedCapitalCallsIndexRoute: typeof AuthenticatedCapitalCallsIndexRoute
  AuthenticatedCashAccountsIndexRoute: typeof AuthenticatedCashAccountsIndexRoute
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
  AuthenticatedClosesIndexRoute: typeof AuthenticatedClosesIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedComplianceIndexRoute: typeof AuthenticatedComplianceIndexRoute
  AuthenticatedCrmIndexRoute: typeof AuthenticatedCrmIndexRoute
  AuthenticatedDealsWithUnitsIndexRoute: typeof AuthenticatedDealsWithUnitsIndexRoute
  AuthenticatedDealsIndexRoute: typeof AuthenticatedDealsIndexRoute
  AuthenticatedDistributionsIndexRoute: typeof AuthenticatedDistributionsIndexRoute
  AuthenticatedEmailTemplatesIndexRoute: typeof AuthenticatedEmailTemplatesIndexRoute
  AuthenticatedEmailsIndexRoute: typeof AuthenticatedEmailsIndexRoute
  AuthenticatedEntitiesIndexRoute: typeof AuthenticatedEntitiesIndexRoute
  AuthenticatedEreborBankingIndexRoute: typeof AuthenticatedEreborBankingIndexRoute
  AuthenticatedEscalationsIndexRoute: typeof AuthenticatedEscalationsIndexRoute
  AuthenticatedExternalRecipientsIndexRoute: typeof AuthenticatedExternalRecipientsIndexRoute
  AuthenticatedFaqsIndexRoute: typeof AuthenticatedFaqsIndexRoute
  AuthenticatedFeedbacksIndexRoute: typeof AuthenticatedFeedbacksIndexRoute
  AuthenticatedFilesIndexRoute: typeof AuthenticatedFilesIndexRoute
  AuthenticatedFinancialsIndexRoute: typeof AuthenticatedFinancialsIndexRoute
  AuthenticatedFundManagerNetworkIndexRoute: typeof AuthenticatedFundManagerNetworkIndexRoute
  AuthenticatedFundManagersIndexRoute: typeof AuthenticatedFundManagersIndexRoute
  AuthenticatedFundraisingIndexRoute: typeof AuthenticatedFundraisingIndexRoute
  AuthenticatedFundsIndexRoute: typeof AuthenticatedFundsIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
  AuthenticatedGranolaIndexRoute: typeof AuthenticatedGranolaIndexRoute
  AuthenticatedIdentitiesIndexRoute: typeof AuthenticatedIdentitiesIndexRoute
  AuthenticatedIncreaseBankingIndexRoute: typeof AuthenticatedIncreaseBankingIndexRoute
  AuthenticatedIntercomIndexRoute: typeof AuthenticatedIntercomIndexRoute
  AuthenticatedInvestmentsIndexRoute: typeof AuthenticatedInvestmentsIndexRoute
  AuthenticatedInvestorNetworkIndexRoute: typeof AuthenticatedInvestorNetworkIndexRoute
  AuthenticatedInvestorRecipientsIndexRoute: typeof AuthenticatedInvestorRecipientsIndexRoute
  AuthenticatedInvestorUpdatesIndexRoute: typeof AuthenticatedInvestorUpdatesIndexRoute
  AuthenticatedInvoiceItemsIndexRoute: typeof AuthenticatedInvoiceItemsIndexRoute
  AuthenticatedInvoiceRequestsIndexRoute: typeof AuthenticatedInvoiceRequestsIndexRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedLedgerIndexRoute: typeof AuthenticatedLedgerIndexRoute
  AuthenticatedLegalDocumentsIndexRoute: typeof AuthenticatedLegalDocumentsIndexRoute
  AuthenticatedLegalTemplatesIndexRoute: typeof AuthenticatedLegalTemplatesIndexRoute
  AuthenticatedLogsIndexRoute: typeof AuthenticatedLogsIndexRoute
  AuthenticatedMailIndexRoute: typeof AuthenticatedMailIndexRoute
  AuthenticatedMasterIndexRoute: typeof AuthenticatedMasterIndexRoute
  AuthenticatedMcpKeysIndexRoute: typeof AuthenticatedMcpKeysIndexRoute
  AuthenticatedMembershipTransfersIndexRoute: typeof AuthenticatedMembershipTransfersIndexRoute
  AuthenticatedMeowBankingIndexRoute: typeof AuthenticatedMeowBankingIndexRoute
  AuthenticatedMigrationsIndexRoute: typeof AuthenticatedMigrationsIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedPledgesIndexRoute: typeof AuthenticatedPledgesIndexRoute
  AuthenticatedProductsPricingIndexRoute: typeof AuthenticatedProductsPricingIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedQueueMonitorIndexRoute: typeof AuthenticatedQueueMonitorIndexRoute
  AuthenticatedRegulatoryFilingsIndexRoute: typeof AuthenticatedRegulatoryFilingsIndexRoute
  AuthenticatedRewardsIndexRoute: typeof AuthenticatedRewardsIndexRoute
  AuthenticatedSalesIndexRoute: typeof AuthenticatedSalesIndexRoute
  AuthenticatedSearchIndexRoute: typeof AuthenticatedSearchIndexRoute
  AuthenticatedSecondariesIndexRoute: typeof AuthenticatedSecondariesIndexRoute
  AuthenticatedSecurityIndexRoute: typeof AuthenticatedSecurityIndexRoute
  AuthenticatedSellOrderRequestsIndexRoute: typeof AuthenticatedSellOrderRequestsIndexRoute
  AuthenticatedSideLettersIndexRoute: typeof AuthenticatedSideLettersIndexRoute
  AuthenticatedSignatureLogsIndexRoute: typeof AuthenticatedSignatureLogsIndexRoute
  AuthenticatedSkillsIndexRoute: typeof AuthenticatedSkillsIndexRoute
  AuthenticatedSpvFeeDiscountsIndexRoute: typeof AuthenticatedSpvFeeDiscountsIndexRoute
  AuthenticatedSupportIndexRoute: typeof AuthenticatedSupportIndexRoute
  AuthenticatedSyndicatesIndexRoute: typeof AuthenticatedSyndicatesIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTaxPenaltiesIndexRoute: typeof AuthenticatedTaxPenaltiesIndexRoute
  AuthenticatedTaxesIndexRoute: typeof AuthenticatedTaxesIndexRoute
  AuthenticatedTransactionsIndexRoute: typeof AuthenticatedTransactionsIndexRoute
  AuthenticatedUnauthorizedIndexRoute: typeof AuthenticatedUnauthorizedIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedV0IndexRoute: typeof AuthenticatedV0IndexRoute
  AuthenticatedValuationEntriesIndexRoute: typeof AuthenticatedValuationEntriesIndexRoute
  AuthenticatedValuationsIndexRoute: typeof AuthenticatedValuationsIndexRoute
  AuthenticatedVendorsIndexRoute: typeof AuthenticatedVendorsIndexRoute
  AuthenticatedWireRequestEscalationsIndexRoute: typeof AuthenticatedWireRequestEscalationsIndexRoute
  AuthenticatedWireRequestsIndexRoute: typeof AuthenticatedWireRequestsIndexRoute
  AuthenticatedAtlasDepartmentPageRoute: typeof AuthenticatedAtlasDepartmentPageRoute
  AuthenticatedAtlasSuggestionsIdRoute: typeof AuthenticatedAtlasSuggestionsIdRoute
  AuthenticatedFinancialsSheetsSheetIdRoute: typeof AuthenticatedFinancialsSheetsSheetIdRoute
  AuthenticatedAccountsIdIndexRoute: typeof AuthenticatedAccountsIdIndexRoute
  AuthenticatedAiStudioSettingsIndexRoute: typeof AuthenticatedAiStudioSettingsIndexRoute
  AuthenticatedAssetsIdIndexRoute: typeof AuthenticatedAssetsIdIndexRoute
  AuthenticatedAtlasDepartmentIndexRoute: typeof AuthenticatedAtlasDepartmentIndexRoute
  AuthenticatedAtlasDocumentationIndexRoute: typeof AuthenticatedAtlasDocumentationIndexRoute
  AuthenticatedAtlasOverviewIndexRoute: typeof AuthenticatedAtlasOverviewIndexRoute
  AuthenticatedAtlasPulseIndexRoute: typeof AuthenticatedAtlasPulseIndexRoute
  AuthenticatedAtlasSuggestionsIndexRoute: typeof AuthenticatedAtlasSuggestionsIndexRoute
  AuthenticatedBankingIdIndexRoute: typeof AuthenticatedBankingIdIndexRoute
  AuthenticatedCapitalCallsIdIndexRoute: typeof AuthenticatedCapitalCallsIdIndexRoute
  AuthenticatedChatIdIndexRoute: typeof AuthenticatedChatIdIndexRoute
  AuthenticatedChatBugsIndexRoute: typeof AuthenticatedChatBugsIndexRoute
  AuthenticatedClosesIdIndexRoute: typeof AuthenticatedClosesIdIndexRoute
  AuthenticatedCompaniesIdIndexRoute: typeof AuthenticatedCompaniesIdIndexRoute
  AuthenticatedComplianceIdIndexRoute: typeof AuthenticatedComplianceIdIndexRoute
  AuthenticatedComplianceBviIndexRoute: typeof AuthenticatedComplianceBviIndexRoute
  AuthenticatedDealsIdIndexRoute: typeof AuthenticatedDealsIdIndexRoute
  AuthenticatedDealsBulkUploadIndexRoute: typeof AuthenticatedDealsBulkUploadIndexRoute
  AuthenticatedDistributionsIdIndexRoute: typeof AuthenticatedDistributionsIdIndexRoute
  AuthenticatedDistributionsWiresIndexRoute: typeof AuthenticatedDistributionsWiresIndexRoute
  AuthenticatedEntitiesIdIndexRoute: typeof AuthenticatedEntitiesIdIndexRoute
  AuthenticatedFinancialsSheetsIndexRoute: typeof AuthenticatedFinancialsSheetsIndexRoute
  AuthenticatedFundraisingContactsIndexRoute: typeof AuthenticatedFundraisingContactsIndexRoute
  AuthenticatedFundraisingDataroomIndexRoute: typeof AuthenticatedFundraisingDataroomIndexRoute
  AuthenticatedFundraisingEmailsIndexRoute: typeof AuthenticatedFundraisingEmailsIndexRoute
  AuthenticatedFundraisingPledgesIndexRoute: typeof AuthenticatedFundraisingPledgesIndexRoute
  AuthenticatedIdentitiesIdIndexRoute: typeof AuthenticatedIdentitiesIdIndexRoute
  AuthenticatedIncreaseBankingAccountIdIndexRoute: typeof AuthenticatedIncreaseBankingAccountIdIndexRoute
  AuthenticatedInvestmentsIdIndexRoute: typeof AuthenticatedInvestmentsIdIndexRoute
  AuthenticatedLogsApiIndexRoute: typeof AuthenticatedLogsApiIndexRoute
  AuthenticatedLogsTrackIndexRoute: typeof AuthenticatedLogsTrackIndexRoute
  AuthenticatedMembershipTransfersIdIndexRoute: typeof AuthenticatedMembershipTransfersIdIndexRoute
  AuthenticatedMeowBankingEntityIdIndexRoute: typeof AuthenticatedMeowBankingEntityIdIndexRoute
  AuthenticatedOrganizationsIdIndexRoute: typeof AuthenticatedOrganizationsIdIndexRoute
  AuthenticatedPledgesIdIndexRoute: typeof AuthenticatedPledgesIdIndexRoute
  AuthenticatedProductsPricingIdIndexRoute: typeof AuthenticatedProductsPricingIdIndexRoute
  AuthenticatedSalesPulseIndexRoute: typeof AuthenticatedSalesPulseIndexRoute
  AuthenticatedScriptsGenerateLegalDocsIndexRoute: typeof AuthenticatedScriptsGenerateLegalDocsIndexRoute
  AuthenticatedSupportSearchIndexRoute: typeof AuthenticatedSupportSearchIndexRoute
  AuthenticatedTaxesDiscrepanciesIndexRoute: typeof AuthenticatedTaxesDiscrepanciesIndexRoute
  AuthenticatedTaxesMetricsIndexRoute: typeof AuthenticatedTaxesMetricsIndexRoute
  AuthenticatedValuationsIdIndexRoute: typeof AuthenticatedValuationsIdIndexRoute
  AuthenticatedComplianceBviFormationsIndexRoute: typeof AuthenticatedComplianceBviFormationsIndexRoute
  AuthenticatedComplianceBviManualIndexRoute: typeof AuthenticatedComplianceBviManualIndexRoute
  AuthenticatedDistributionsIdDistributionsEventsIndexRoute: typeof AuthenticatedDistributionsIdDistributionsEventsIndexRoute
  AuthenticatedLedgerAccountsIdIndexRoute: typeof AuthenticatedLedgerAccountsIdIndexRoute
  AuthenticatedSyndicatesIdAdminIndexRoute: typeof AuthenticatedSyndicatesIdAdminIndexRoute
  AuthenticatedTaxesEntity_idTax_yearIndexRoute: typeof AuthenticatedTaxesEntity_idTax_yearIndexRoute
  AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute: typeof AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute
  AuthenticatedComplianceBviFormationsIdIndexRoute: typeof AuthenticatedComplianceBviFormationsIdIndexRoute
  AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute: typeof AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountsSpendRoute: AuthenticatedAccountsSpendRoute,
  AuthenticatedAccountsSpendByProductRoute:
    AuthenticatedAccountsSpendByProductRoute,
  AuthenticatedAiStudioChatIdRoute: AuthenticatedAiStudioChatIdRoute,
  AuthenticatedAccessManagementIndexRoute:
    AuthenticatedAccessManagementIndexRoute,
  AuthenticatedAccountsIndexRoute: AuthenticatedAccountsIndexRoute,
  AuthenticatedActivitiesIndexRoute: AuthenticatedActivitiesIndexRoute,
  AuthenticatedAdministratorsIndexRoute: AuthenticatedAdministratorsIndexRoute,
  AuthenticatedAgentsIndexRoute: AuthenticatedAgentsIndexRoute,
  AuthenticatedAiStudioIndexRoute: AuthenticatedAiStudioIndexRoute,
  AuthenticatedAllocationsBankingIndexRoute:
    AuthenticatedAllocationsBankingIndexRoute,
  AuthenticatedApiAccessManagerIndexRoute:
    AuthenticatedApiAccessManagerIndexRoute,
  AuthenticatedAppManagementIndexRoute: AuthenticatedAppManagementIndexRoute,
  AuthenticatedArchiveRequestsIndexRoute:
    AuthenticatedArchiveRequestsIndexRoute,
  AuthenticatedAssetValuationsIndexRoute:
    AuthenticatedAssetValuationsIndexRoute,
  AuthenticatedAssetsCleanupIndexRoute: AuthenticatedAssetsCleanupIndexRoute,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
  AuthenticatedAtlasIndexRoute: AuthenticatedAtlasIndexRoute,
  AuthenticatedBankingProvidersIndexRoute:
    AuthenticatedBankingProvidersIndexRoute,
  AuthenticatedBankingIndexRoute: AuthenticatedBankingIndexRoute,
  AuthenticatedBannersIndexRoute: AuthenticatedBannersIndexRoute,
  AuthenticatedBlueSkyFeesIndexRoute: AuthenticatedBlueSkyFeesIndexRoute,
  AuthenticatedBrokerageAccountsAlpacaIndexRoute:
    AuthenticatedBrokerageAccountsAlpacaIndexRoute,
  AuthenticatedBrokerageAccountsIndexRoute:
    AuthenticatedBrokerageAccountsIndexRoute,
  AuthenticatedCapitalCallsIndexRoute: AuthenticatedCapitalCallsIndexRoute,
  AuthenticatedCashAccountsIndexRoute: AuthenticatedCashAccountsIndexRoute,
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
  AuthenticatedClosesIndexRoute: AuthenticatedClosesIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedComplianceIndexRoute: AuthenticatedComplianceIndexRoute,
  AuthenticatedCrmIndexRoute: AuthenticatedCrmIndexRoute,
  AuthenticatedDealsWithUnitsIndexRoute: AuthenticatedDealsWithUnitsIndexRoute,
  AuthenticatedDealsIndexRoute: AuthenticatedDealsIndexRoute,
  AuthenticatedDistributionsIndexRoute: AuthenticatedDistributionsIndexRoute,
  AuthenticatedEmailTemplatesIndexRoute: AuthenticatedEmailTemplatesIndexRoute,
  AuthenticatedEmailsIndexRoute: AuthenticatedEmailsIndexRoute,
  AuthenticatedEntitiesIndexRoute: AuthenticatedEntitiesIndexRoute,
  AuthenticatedEreborBankingIndexRoute: AuthenticatedEreborBankingIndexRoute,
  AuthenticatedEscalationsIndexRoute: AuthenticatedEscalationsIndexRoute,
  AuthenticatedExternalRecipientsIndexRoute:
    AuthenticatedExternalRecipientsIndexRoute,
  AuthenticatedFaqsIndexRoute: AuthenticatedFaqsIndexRoute,
  AuthenticatedFeedbacksIndexRoute: AuthenticatedFeedbacksIndexRoute,
  AuthenticatedFilesIndexRoute: AuthenticatedFilesIndexRoute,
  AuthenticatedFinancialsIndexRoute: AuthenticatedFinancialsIndexRoute,
  AuthenticatedFundManagerNetworkIndexRoute:
    AuthenticatedFundManagerNetworkIndexRoute,
  AuthenticatedFundManagersIndexRoute: AuthenticatedFundManagersIndexRoute,
  AuthenticatedFundraisingIndexRoute: AuthenticatedFundraisingIndexRoute,
  AuthenticatedFundsIndexRoute: AuthenticatedFundsIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
  AuthenticatedGranolaIndexRoute: AuthenticatedGranolaIndexRoute,
  AuthenticatedIdentitiesIndexRoute: AuthenticatedIdentitiesIndexRoute,
  AuthenticatedIncreaseBankingIndexRoute:
    AuthenticatedIncreaseBankingIndexRoute,
  AuthenticatedIntercomIndexRoute: AuthenticatedIntercomIndexRoute,
  AuthenticatedInvestmentsIndexRoute: AuthenticatedInvestmentsIndexRoute,
  AuthenticatedInvestorNetworkIndexRoute:
    AuthenticatedInvestorNetworkIndexRoute,
  AuthenticatedInvestorRecipientsIndexRoute:
    AuthenticatedInvestorRecipientsIndexRoute,
  AuthenticatedInvestorUpdatesIndexRoute:
    AuthenticatedInvestorUpdatesIndexRoute,
  AuthenticatedInvoiceItemsIndexRoute: AuthenticatedInvoiceItemsIndexRoute,
  AuthenticatedInvoiceRequestsIndexRoute:
    AuthenticatedInvoiceRequestsIndexRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedLedgerIndexRoute: AuthenticatedLedgerIndexRoute,
  AuthenticatedLegalDocumentsIndexRoute: AuthenticatedLegalDocumentsIndexRoute,
  AuthenticatedLegalTemplatesIndexRoute: AuthenticatedLegalTemplatesIndexRoute,
  AuthenticatedLogsIndexRoute: AuthenticatedLogsIndexRoute,
  AuthenticatedMailIndexRoute: AuthenticatedMailIndexRoute,
  AuthenticatedMasterIndexRoute: AuthenticatedMasterIndexRoute,
  AuthenticatedMcpKeysIndexRoute: AuthenticatedMcpKeysIndexRoute,
  AuthenticatedMembershipTransfersIndexRoute:
    AuthenticatedMembershipTransfersIndexRoute,
  AuthenticatedMeowBankingIndexRoute: AuthenticatedMeowBankingIndexRoute,
  AuthenticatedMigrationsIndexRoute: AuthenticatedMigrationsIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedPledgesIndexRoute: AuthenticatedPledgesIndexRoute,
  AuthenticatedProductsPricingIndexRoute:
    AuthenticatedProductsPricingIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedQueueMonitorIndexRoute: AuthenticatedQueueMonitorIndexRoute,
  AuthenticatedRegulatoryFilingsIndexRoute:
    AuthenticatedRegulatoryFilingsIndexRoute,
  AuthenticatedRewardsIndexRoute: AuthenticatedRewardsIndexRoute,
  AuthenticatedSalesIndexRoute: AuthenticatedSalesIndexRoute,
  AuthenticatedSearchIndexRoute: AuthenticatedSearchIndexRoute,
  AuthenticatedSecondariesIndexRoute: AuthenticatedSecondariesIndexRoute,
  AuthenticatedSecurityIndexRoute: AuthenticatedSecurityIndexRoute,
  AuthenticatedSellOrderRequestsIndexRoute:
    AuthenticatedSellOrderRequestsIndexRoute,
  AuthenticatedSideLettersIndexRoute: AuthenticatedSideLettersIndexRoute,
  AuthenticatedSignatureLogsIndexRoute: AuthenticatedSignatureLogsIndexRoute,
  AuthenticatedSkillsIndexRoute: AuthenticatedSkillsIndexRoute,
  AuthenticatedSpvFeeDiscountsIndexRoute:
    AuthenticatedSpvFeeDiscountsIndexRoute,
  AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute,
  AuthenticatedSyndicatesIndexRoute: AuthenticatedSyndicatesIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTaxPenaltiesIndexRoute: AuthenticatedTaxPenaltiesIndexRoute,
  AuthenticatedTaxesIndexRoute: AuthenticatedTaxesIndexRoute,
  AuthenticatedTransactionsIndexRoute: AuthenticatedTransactionsIndexRoute,
  AuthenticatedUnauthorizedIndexRoute: AuthenticatedUnauthorizedIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedV0IndexRoute: AuthenticatedV0IndexRoute,
  AuthenticatedValuationEntriesIndexRoute:
    AuthenticatedValuationEntriesIndexRoute,
  AuthenticatedValuationsIndexRoute: AuthenticatedValuationsIndexRoute,
  AuthenticatedVendorsIndexRoute: AuthenticatedVendorsIndexRoute,
  AuthenticatedWireRequestEscalationsIndexRoute:
    AuthenticatedWireRequestEscalationsIndexRoute,
  AuthenticatedWireRequestsIndexRoute: AuthenticatedWireRequestsIndexRoute,
  AuthenticatedAtlasDepartmentPageRoute: AuthenticatedAtlasDepartmentPageRoute,
  AuthenticatedAtlasSuggestionsIdRoute: AuthenticatedAtlasSuggestionsIdRoute,
  AuthenticatedFinancialsSheetsSheetIdRoute:
    AuthenticatedFinancialsSheetsSheetIdRoute,
  AuthenticatedAccountsIdIndexRoute: AuthenticatedAccountsIdIndexRoute,
  AuthenticatedAiStudioSettingsIndexRoute:
    AuthenticatedAiStudioSettingsIndexRoute,
  AuthenticatedAssetsIdIndexRoute: AuthenticatedAssetsIdIndexRoute,
  AuthenticatedAtlasDepartmentIndexRoute:
    AuthenticatedAtlasDepartmentIndexRoute,
  AuthenticatedAtlasDocumentationIndexRoute:
    AuthenticatedAtlasDocumentationIndexRoute,
  AuthenticatedAtlasOverviewIndexRoute: AuthenticatedAtlasOverviewIndexRoute,
  AuthenticatedAtlasPulseIndexRoute: AuthenticatedAtlasPulseIndexRoute,
  AuthenticatedAtlasSuggestionsIndexRoute:
    AuthenticatedAtlasSuggestionsIndexRoute,
  AuthenticatedBankingIdIndexRoute: AuthenticatedBankingIdIndexRoute,
  AuthenticatedCapitalCallsIdIndexRoute: AuthenticatedCapitalCallsIdIndexRoute,
  AuthenticatedChatIdIndexRoute: AuthenticatedChatIdIndexRoute,
  AuthenticatedChatBugsIndexRoute: AuthenticatedChatBugsIndexRoute,
  AuthenticatedClosesIdIndexRoute: AuthenticatedClosesIdIndexRoute,
  AuthenticatedCompaniesIdIndexRoute: AuthenticatedCompaniesIdIndexRoute,
  AuthenticatedComplianceIdIndexRoute: AuthenticatedComplianceIdIndexRoute,
  AuthenticatedComplianceBviIndexRoute: AuthenticatedComplianceBviIndexRoute,
  AuthenticatedDealsIdIndexRoute: AuthenticatedDealsIdIndexRoute,
  AuthenticatedDealsBulkUploadIndexRoute:
    AuthenticatedDealsBulkUploadIndexRoute,
  AuthenticatedDistributionsIdIndexRoute:
    AuthenticatedDistributionsIdIndexRoute,
  AuthenticatedDistributionsWiresIndexRoute:
    AuthenticatedDistributionsWiresIndexRoute,
  AuthenticatedEntitiesIdIndexRoute: AuthenticatedEntitiesIdIndexRoute,
  AuthenticatedFinancialsSheetsIndexRoute:
    AuthenticatedFinancialsSheetsIndexRoute,
  AuthenticatedFundraisingContactsIndexRoute:
    AuthenticatedFundraisingContactsIndexRoute,
  AuthenticatedFundraisingDataroomIndexRoute:
    AuthenticatedFundraisingDataroomIndexRoute,
  AuthenticatedFundraisingEmailsIndexRoute:
    AuthenticatedFundraisingEmailsIndexRoute,
  AuthenticatedFundraisingPledgesIndexRoute:
    AuthenticatedFundraisingPledgesIndexRoute,
  AuthenticatedIdentitiesIdIndexRoute: AuthenticatedIdentitiesIdIndexRoute,
  AuthenticatedIncreaseBankingAccountIdIndexRoute:
    AuthenticatedIncreaseBankingAccountIdIndexRoute,
  AuthenticatedInvestmentsIdIndexRoute: AuthenticatedInvestmentsIdIndexRoute,
  AuthenticatedLogsApiIndexRoute: AuthenticatedLogsApiIndexRoute,
  AuthenticatedLogsTrackIndexRoute: AuthenticatedLogsTrackIndexRoute,
  AuthenticatedMembershipTransfersIdIndexRoute:
    AuthenticatedMembershipTransfersIdIndexRoute,
  AuthenticatedMeowBankingEntityIdIndexRoute:
    AuthenticatedMeowBankingEntityIdIndexRoute,
  AuthenticatedOrganizationsIdIndexRoute:
    AuthenticatedOrganizationsIdIndexRoute,
  AuthenticatedPledgesIdIndexRoute: AuthenticatedPledgesIdIndexRoute,
  AuthenticatedProductsPricingIdIndexRoute:
    AuthenticatedProductsPricingIdIndexRoute,
  AuthenticatedSalesPulseIndexRoute: AuthenticatedSalesPulseIndexRoute,
  AuthenticatedScriptsGenerateLegalDocsIndexRoute:
    AuthenticatedScriptsGenerateLegalDocsIndexRoute,
  AuthenticatedSupportSearchIndexRoute: AuthenticatedSupportSearchIndexRoute,
  AuthenticatedTaxesDiscrepanciesIndexRoute:
    AuthenticatedTaxesDiscrepanciesIndexRoute,
  AuthenticatedTaxesMetricsIndexRoute: AuthenticatedTaxesMetricsIndexRoute,
  AuthenticatedValuationsIdIndexRoute: AuthenticatedValuationsIdIndexRoute,
  AuthenticatedComplianceBviFormationsIndexRoute:
    AuthenticatedComplianceBviFormationsIndexRoute,
  AuthenticatedComplianceBviManualIndexRoute:
    AuthenticatedComplianceBviManualIndexRoute,
  AuthenticatedDistributionsIdDistributionsEventsIndexRoute:
    AuthenticatedDistributionsIdDistributionsEventsIndexRoute,
  AuthenticatedLedgerAccountsIdIndexRoute:
    AuthenticatedLedgerAccountsIdIndexRoute,
  AuthenticatedSyndicatesIdAdminIndexRoute:
    AuthenticatedSyndicatesIdAdminIndexRoute,
  AuthenticatedTaxesEntity_idTax_yearIndexRoute:
    AuthenticatedTaxesEntity_idTax_yearIndexRoute,
  AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute:
    AuthenticatedTaxesDiscrepanciesTax_yearIndexRoute,
  AuthenticatedComplianceBviFormationsIdIndexRoute:
    AuthenticatedComplianceBviFormationsIdIndexRoute,
  AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute:
    AuthenticatedDistributionsIdDistributionsEventsEventIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
